/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, string>; output: Record<string, string> };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: number; output: number };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File };
}

export interface AlreadyInSpaceDataType {
  __typename?: 'AlreadyInSpaceDataType';
  spaceId: Scalars['String']['output'];
}

export interface ArticleSummaryInput {
  /** 文章内容 */
  content: Scalars['String']['input'];
  /** 文章标题 */
  title: Scalars['String']['input'];
}

export interface ArticleSummaryResult {
  __typename?: 'ArticleSummaryResult';
  /** 返回消息 */
  message: Scalars['String']['output'];
  /** 原文章标题 */
  originalTitle: Scalars['String']['output'];
  /** 总结是否成功 */
  success: Scalars['Boolean']['output'];
  /** 文章总结内容 */
  summary: Scalars['String']['output'];
}

export interface AssignTaskInput {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
  toUserId: Scalars['String']['input'];
}

export interface AssignmentResult {
  __typename?: 'AssignmentResult';
  assignmentId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

/** Task assignment status */
export enum AssignmentStatus {
  Accepted = 'Accepted',
  Expired = 'Expired',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export interface BatchAssignTaskInput {
  message?: InputMaybe<Scalars['String']['input']>;
  taskIds: Array<Scalars['String']['input']>;
  toUserId: Scalars['String']['input'];
}

export interface BatchAssignmentResult {
  __typename?: 'BatchAssignmentResult';
  assignmentIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
}

export interface BlobNotFoundDataType {
  __typename?: 'BlobNotFoundDataType';
  blobId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export enum ChatHistoryOrder {
  asc = 'asc',
  desc = 'desc',
}

export interface ChatMessage {
  __typename?: 'ChatMessage';
  attachments: Maybe<Array<Scalars['String']['output']>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Maybe<Scalars['ID']['output']>;
  params: Maybe<Scalars['JSON']['output']>;
  role: Scalars['String']['output'];
}

export interface ContributionEntryInput {
  /** 文档ID */
  key: Scalars['String']['input'];
  /** 文档内容 */
  value: Scalars['String']['input'];
}

export interface Copilot {
  __typename?: 'Copilot';
  /** Get the session list of actions in the workspace */
  actions: Array<Scalars['String']['output']>;
  /** Get the session list of chats in the workspace */
  chats: Array<Scalars['String']['output']>;
  histories: Array<CopilotHistories>;
  /** Get the quota of the user in the workspace */
  quota: CopilotQuota;
  workspaceId: Maybe<Scalars['ID']['output']>;
}

export interface CopilotHistoriesArgs {
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}

export interface CopilotHistories {
  __typename?: 'CopilotHistories';
  /** An mark identifying which view to use to display the session */
  action: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  messages: Array<ChatMessage>;
  sessionId: Scalars['String']['output'];
  /** The number of tokens used in the session */
  tokens: Scalars['Int']['output'];
}

export interface CopilotMessageNotFoundDataType {
  __typename?: 'CopilotMessageNotFoundDataType';
  messageId: Scalars['String']['output'];
}

export enum CopilotModels {
  DallE3 = 'DallE3',
  Gpt4Omni = 'Gpt4Omni',
  Gpt4Omni0806 = 'Gpt4Omni0806',
  Gpt4OmniMini = 'Gpt4OmniMini',
  Gpt4OmniMini0718 = 'Gpt4OmniMini0718',
  TextEmbedding3Large = 'TextEmbedding3Large',
  TextEmbedding3Small = 'TextEmbedding3Small',
  TextEmbeddingAda002 = 'TextEmbeddingAda002',
  TextModerationLatest = 'TextModerationLatest',
  TextModerationStable = 'TextModerationStable',
}

export interface CopilotPromptConfigInput {
  frequencyPenalty?: InputMaybe<Scalars['Float']['input']>;
  jsonMode?: InputMaybe<Scalars['Boolean']['input']>;
  presencePenalty?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  topP?: InputMaybe<Scalars['Float']['input']>;
}

export interface CopilotPromptConfigType {
  __typename?: 'CopilotPromptConfigType';
  frequencyPenalty: Maybe<Scalars['Float']['output']>;
  jsonMode: Maybe<Scalars['Boolean']['output']>;
  presencePenalty: Maybe<Scalars['Float']['output']>;
  temperature: Maybe<Scalars['Float']['output']>;
  topP: Maybe<Scalars['Float']['output']>;
}

export interface CopilotPromptMessageInput {
  content: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  role: CopilotPromptMessageRole;
}

export enum CopilotPromptMessageRole {
  assistant = 'assistant',
  system = 'system',
  user = 'user',
}

export interface CopilotPromptMessageType {
  __typename?: 'CopilotPromptMessageType';
  content: Scalars['String']['output'];
  params: Maybe<Scalars['JSON']['output']>;
  role: CopilotPromptMessageRole;
}

export interface CopilotPromptNotFoundDataType {
  __typename?: 'CopilotPromptNotFoundDataType';
  name: Scalars['String']['output'];
}

export interface CopilotPromptType {
  __typename?: 'CopilotPromptType';
  action: Maybe<Scalars['String']['output']>;
  config: Maybe<CopilotPromptConfigType>;
  messages: Array<CopilotPromptMessageType>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CopilotProviderSideErrorDataType {
  __typename?: 'CopilotProviderSideErrorDataType';
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
  provider: Scalars['String']['output'];
}

export interface CopilotQuota {
  __typename?: 'CopilotQuota';
  limit: Maybe<Scalars['SafeInt']['output']>;
  used: Scalars['SafeInt']['output'];
}

export interface CreateChatMessageInput {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  blobs?: InputMaybe<Array<Scalars['Upload']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  sessionId: Scalars['String']['input'];
}

export interface CreateChatSessionInput {
  docId: Scalars['String']['input'];
  /** The prompt name to use for the session */
  promptName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface CreateCheckoutSessionInput {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<SubscriptionPlan>;
  recurring?: InputMaybe<SubscriptionRecurring>;
  successCallbackLink: Scalars['String']['input'];
  variant?: InputMaybe<SubscriptionVariant>;
}

export interface CreateCopilotPromptInput {
  action?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CopilotPromptConfigInput>;
  messages: Array<CopilotPromptMessageInput>;
  model: CopilotModels;
  name: Scalars['String']['input'];
}

export interface CreateDiscussionGroupInput {
  coverImage: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** 初始成员用户ID列表 */
  memberIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scope?: DiscussionScope;
  workspaceId: Scalars['String']['input'];
}

export interface CreateDocumentTemplateInput {
  documentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface CreateSubtaskInput {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completionNote?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<NestedUserInput>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Associated document ID */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Associated document URL */
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Associated discussion group IDs array */
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the subtask is public */
  isPublic?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  owner?: InputMaybe<NestedUserInput>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** Multiple owner IDs array */
  ownerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<TaskPermissionInput>>;
  /** Points reward for completing this task */
  points?: Scalars['Int']['input'];
  priority?: TaskPriority;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
  /** Task type: 1-OutlineCollection, 2-ContentWriting */
  taskType?: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface CreateTaskInput {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completionNote?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<NestedUserInput>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Associated document ID */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Associated document URL */
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Associated discussion group IDs array */
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the task is public (only applies to subtasks) */
  isPublic?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  owner?: InputMaybe<NestedUserInput>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** Multiple owner IDs array */
  ownerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parent?: InputMaybe<NestedTaskInput>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<TaskPermissionInput>>;
  /** Points reward for completing this main task */
  points?: Scalars['Int']['input'];
  priority?: TaskPriority;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
  subtasks?: InputMaybe<Array<CreateSubtaskInput>>;
  /** Task type: 1-OutlineCollection, 2-ContentWriting */
  taskType?: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface CreateUserInput {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface CredentialsRequirementType {
  __typename?: 'CredentialsRequirementType';
  password: PasswordLimitsType;
}

export interface DeleteAccount {
  __typename?: 'DeleteAccount';
  success: Scalars['Boolean']['output'];
}

export interface DeleteSessionInput {
  docId: Scalars['String']['input'];
  sessionIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface DeleteTemplateResult {
  __typename?: 'DeleteTemplateResult';
  message: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
}

export interface DiscussionGroupFilterInput {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** 主题名称模糊搜索 */
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<DiscussionScope>;
  status?: InputMaybe<DiscussionGroupStatus>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface DiscussionGroupListInput {
  filter?: InputMaybe<DiscussionGroupFilterInput>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}

export interface DiscussionGroupMemberType {
  __typename?: 'DiscussionGroupMemberType';
  group: DiscussionGroupType;
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  joinedAt: Scalars['DateTime']['output'];
  user: UserType;
  userId: Scalars['String']['output'];
}

/** Discussion group status */
export enum DiscussionGroupStatus {
  /** 活跃状态 */
  Active = 'Active',
  /** 已归档 */
  Archived = 'Archived',
}

export interface DiscussionGroupType {
  __typename?: 'DiscussionGroupType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creator: UserType;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<DiscussionGroupMemberType>;
  messageCount: Scalars['Int']['output'];
  messages: Array<DiscussionMessageType>;
  name: Scalars['String']['output'];
  scope: DiscussionScope;
  status: DiscussionGroupStatus;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface DiscussionMessageType {
  __typename?: 'DiscussionMessageType';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  group: DiscussionGroupType;
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  replies: Array<DiscussionMessageType>;
  replyMessage: Maybe<DiscussionMessageType>;
  replyTo: Maybe<Scalars['String']['output']>;
  sender: UserType;
  senderId: Scalars['String']['output'];
  status: MessageStatus;
  type: MessageType;
}

/** Discussion group scope */
export enum DiscussionScope {
  /** 指定成员讨论 */
  Invited = 'Invited',
  /** 私有讨论 */
  Private = 'Private',
  /** 公开讨论 */
  Public = 'Public',
}

export interface DocAccessDeniedDataType {
  __typename?: 'DocAccessDeniedDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface DocHistoryNotFoundDataType {
  __typename?: 'DocHistoryNotFoundDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
}

export interface DocHistoryType {
  __typename?: 'DocHistoryType';
  editor: Maybe<EditorType>;
  id: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface DocNotFoundDataType {
  __typename?: 'DocNotFoundDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface DocumentTaskInfo {
  __typename?: 'DocumentTaskInfo';
  /** 是否为主任务 */
  isMainTask: Scalars['Boolean']['output'];
  /** 父任务ID */
  parentTaskId: Maybe<Scalars['ID']['output']>;
  /** 父任务名称 */
  parentTaskName: Maybe<Scalars['String']['output']>;
  /** 父任务状态 */
  parentTaskStatus: Maybe<TaskStatus>;
  /** 任务ID */
  taskId: Scalars['ID']['output'];
  /** 任务名称 */
  taskName: Scalars['String']['output'];
  /** 任务状态 */
  taskStatus: TaskStatus;
}

export interface DocumentTaskQueryInput {
  /** 文档ID列表 */
  documentIds: Array<Scalars['String']['input']>;
}

export interface DocumentTaskResult {
  __typename?: 'DocumentTaskResult';
  /** 文档ID */
  documentId: Scalars['String']['output'];
  /** 是否找到关联任务 */
  hasTask: Scalars['Boolean']['output'];
  /** 返回消息 */
  message: Scalars['String']['output'];
  /** 文档关联的任务信息列表 */
  taskInfos: Array<DocumentTaskInfo>;
  /** 关联任务总数 */
  totalCount: Scalars['Int']['output'];
}

export interface DocumentTemplateFilterInput {
  /** 创建者用户ID */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** 关联文档ID */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** 模板名称模糊搜索 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 工作区ID */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface DocumentTemplateInfoResult {
  __typename?: 'DocumentTemplateInfoResult';
  isTemplate: Scalars['Boolean']['output'];
  templateId: Maybe<Scalars['String']['output']>;
  templateName: Maybe<Scalars['String']['output']>;
}

export interface DocumentTemplateListInput {
  filter?: InputMaybe<DocumentTemplateFilterInput>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  /** 排序字段 */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** 排序方向 asc/desc */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}

export interface DocumentTemplateListResult {
  __typename?: 'DocumentTemplateListResult';
  list: Array<DocumentTemplateType>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface DocumentTemplateResult {
  __typename?: 'DocumentTemplateResult';
  message: Scalars['String']['output'];
  template: DocumentTemplateType;
}

export interface DocumentTemplateType {
  __typename?: 'DocumentTemplateType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creator: UserType;
  documentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Maybe<Scalars['String']['output']>;
}

export interface EditorType {
  __typename?: 'EditorType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export type ErrorDataUnion =
  | AlreadyInSpaceDataType
  | BlobNotFoundDataType
  | CopilotMessageNotFoundDataType
  | CopilotPromptNotFoundDataType
  | CopilotProviderSideErrorDataType
  | DocAccessDeniedDataType
  | DocHistoryNotFoundDataType
  | DocNotFoundDataType
  | InvalidEmailDataType
  | InvalidHistoryTimestampDataType
  | InvalidPasswordLengthDataType
  | InvalidRuntimeConfigTypeDataType
  | MemberNotFoundInSpaceDataType
  | MissingOauthQueryParameterDataType
  | NotInSpaceDataType
  | RuntimeConfigNotFoundDataType
  | SameSubscriptionRecurringDataType
  | SpaceAccessDeniedDataType
  | SpaceNotFoundDataType
  | SpaceOwnerNotFoundDataType
  | SubscriptionAlreadyExistsDataType
  | SubscriptionNotExistsDataType
  | SubscriptionPlanNotFoundDataType
  | UnknownOauthProviderDataType
  | UnsupportedSubscriptionPlanDataType
  | VersionRejectedDataType
  | WrongSignInCredentialsDataType;

export enum ErrorNames {
  ACCESS_DENIED = 'ACCESS_DENIED',
  ACTION_FORBIDDEN = 'ACTION_FORBIDDEN',
  ALREADY_IN_SPACE = 'ALREADY_IN_SPACE',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
  BLOB_NOT_FOUND = 'BLOB_NOT_FOUND',
  BLOB_QUOTA_EXCEEDED = 'BLOB_QUOTA_EXCEEDED',
  CANNOT_DELETE_ALL_ADMIN_ACCOUNT = 'CANNOT_DELETE_ALL_ADMIN_ACCOUNT',
  CANNOT_DELETE_OWN_ACCOUNT = 'CANNOT_DELETE_OWN_ACCOUNT',
  CANT_CHANGE_SPACE_OWNER = 'CANT_CHANGE_SPACE_OWNER',
  CANT_UPDATE_ONETIME_PAYMENT_SUBSCRIPTION = 'CANT_UPDATE_ONETIME_PAYMENT_SUBSCRIPTION',
  CAPTCHA_VERIFICATION_FAILED = 'CAPTCHA_VERIFICATION_FAILED',
  COPILOT_ACTION_TAKEN = 'COPILOT_ACTION_TAKEN',
  COPILOT_FAILED_TO_CREATE_MESSAGE = 'COPILOT_FAILED_TO_CREATE_MESSAGE',
  COPILOT_FAILED_TO_GENERATE_TEXT = 'COPILOT_FAILED_TO_GENERATE_TEXT',
  COPILOT_MESSAGE_NOT_FOUND = 'COPILOT_MESSAGE_NOT_FOUND',
  COPILOT_PROMPT_INVALID = 'COPILOT_PROMPT_INVALID',
  COPILOT_PROMPT_NOT_FOUND = 'COPILOT_PROMPT_NOT_FOUND',
  COPILOT_PROVIDER_SIDE_ERROR = 'COPILOT_PROVIDER_SIDE_ERROR',
  COPILOT_QUOTA_EXCEEDED = 'COPILOT_QUOTA_EXCEEDED',
  COPILOT_SESSION_DELETED = 'COPILOT_SESSION_DELETED',
  COPILOT_SESSION_NOT_FOUND = 'COPILOT_SESSION_NOT_FOUND',
  CUSTOMER_PORTAL_CREATE_FAILED = 'CUSTOMER_PORTAL_CREATE_FAILED',
  DOC_ACCESS_DENIED = 'DOC_ACCESS_DENIED',
  DOC_HISTORY_NOT_FOUND = 'DOC_HISTORY_NOT_FOUND',
  DOC_NOT_FOUND = 'DOC_NOT_FOUND',
  EARLY_ACCESS_REQUIRED = 'EARLY_ACCESS_REQUIRED',
  EMAIL_ALREADY_USED = 'EMAIL_ALREADY_USED',
  EMAIL_TOKEN_NOT_FOUND = 'EMAIL_TOKEN_NOT_FOUND',
  EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED',
  EXPECT_TO_PUBLISH_PAGE = 'EXPECT_TO_PUBLISH_PAGE',
  EXPECT_TO_REVOKE_PUBLIC_PAGE = 'EXPECT_TO_REVOKE_PUBLIC_PAGE',
  FAILED_TO_CHECKOUT = 'FAILED_TO_CHECKOUT',
  FAILED_TO_SAVE_UPDATES = 'FAILED_TO_SAVE_UPDATES',
  FAILED_TO_UPSERT_SNAPSHOT = 'FAILED_TO_UPSERT_SNAPSHOT',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_CHECKOUT_PARAMETERS = 'INVALID_CHECKOUT_PARAMETERS',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_EMAIL_TOKEN = 'INVALID_EMAIL_TOKEN',
  INVALID_HISTORY_TIMESTAMP = 'INVALID_HISTORY_TIMESTAMP',
  INVALID_OAUTH_CALLBACK_STATE = 'INVALID_OAUTH_CALLBACK_STATE',
  INVALID_PASSWORD_LENGTH = 'INVALID_PASSWORD_LENGTH',
  INVALID_RUNTIME_CONFIG_TYPE = 'INVALID_RUNTIME_CONFIG_TYPE',
  INVALID_SUBSCRIPTION_PARAMETERS = 'INVALID_SUBSCRIPTION_PARAMETERS',
  LINK_EXPIRED = 'LINK_EXPIRED',
  MAILER_SERVICE_IS_NOT_CONFIGURED = 'MAILER_SERVICE_IS_NOT_CONFIGURED',
  MEMBER_NOT_FOUND_IN_SPACE = 'MEMBER_NOT_FOUND_IN_SPACE',
  MEMBER_QUOTA_EXCEEDED = 'MEMBER_QUOTA_EXCEEDED',
  MISSING_OAUTH_QUERY_PARAMETER = 'MISSING_OAUTH_QUERY_PARAMETER',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IN_SPACE = 'NOT_IN_SPACE',
  NO_COPILOT_PROVIDER_AVAILABLE = 'NO_COPILOT_PROVIDER_AVAILABLE',
  OAUTH_ACCOUNT_ALREADY_CONNECTED = 'OAUTH_ACCOUNT_ALREADY_CONNECTED',
  OAUTH_STATE_EXPIRED = 'OAUTH_STATE_EXPIRED',
  PAGE_IS_NOT_PUBLIC = 'PAGE_IS_NOT_PUBLIC',
  PASSWORD_REQUIRED = 'PASSWORD_REQUIRED',
  RUNTIME_CONFIG_NOT_FOUND = 'RUNTIME_CONFIG_NOT_FOUND',
  SAME_EMAIL_PROVIDED = 'SAME_EMAIL_PROVIDED',
  SAME_SUBSCRIPTION_RECURRING = 'SAME_SUBSCRIPTION_RECURRING',
  SIGN_UP_FORBIDDEN = 'SIGN_UP_FORBIDDEN',
  SPACE_ACCESS_DENIED = 'SPACE_ACCESS_DENIED',
  SPACE_NOT_FOUND = 'SPACE_NOT_FOUND',
  SPACE_OWNER_NOT_FOUND = 'SPACE_OWNER_NOT_FOUND',
  SUBSCRIPTION_ALREADY_EXISTS = 'SUBSCRIPTION_ALREADY_EXISTS',
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  SUBSCRIPTION_HAS_BEEN_CANCELED = 'SUBSCRIPTION_HAS_BEEN_CANCELED',
  SUBSCRIPTION_HAS_NOT_BEEN_CANCELED = 'SUBSCRIPTION_HAS_NOT_BEEN_CANCELED',
  SUBSCRIPTION_NOT_EXISTS = 'SUBSCRIPTION_NOT_EXISTS',
  SUBSCRIPTION_PLAN_NOT_FOUND = 'SUBSCRIPTION_PLAN_NOT_FOUND',
  TOO_MANY_REQUEST = 'TOO_MANY_REQUEST',
  UNKNOWN_OAUTH_PROVIDER = 'UNKNOWN_OAUTH_PROVIDER',
  UNSPLASH_IS_NOT_CONFIGURED = 'UNSPLASH_IS_NOT_CONFIGURED',
  UNSUPPORTED_SUBSCRIPTION_PLAN = 'UNSUPPORTED_SUBSCRIPTION_PLAN',
  USER_AVATAR_NOT_FOUND = 'USER_AVATAR_NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  VERSION_REJECTED = 'VERSION_REJECTED',
  WORKSPACE_ID_REQUIRED_FOR_TEAM_SUBSCRIPTION = 'WORKSPACE_ID_REQUIRED_FOR_TEAM_SUBSCRIPTION',
  WORKSPACE_ID_REQUIRED_TO_UPDATE_TEAM_SUBSCRIPTION = 'WORKSPACE_ID_REQUIRED_TO_UPDATE_TEAM_SUBSCRIPTION',
  WRONG_SIGN_IN_CREDENTIALS = 'WRONG_SIGN_IN_CREDENTIALS',
  WRONG_SIGN_IN_METHOD = 'WRONG_SIGN_IN_METHOD',
}

/** The type of workspace feature */
export enum FeatureType {
  AIEarlyAccess = 'AIEarlyAccess',
  Admin = 'Admin',
  Copilot = 'Copilot',
  EarlyAccess = 'EarlyAccess',
  UnlimitedCopilot = 'UnlimitedCopilot',
  UnlimitedWorkspace = 'UnlimitedWorkspace',
}

export interface ForkChatSessionInput {
  docId: Scalars['String']['input'];
  /** Identify a message in the array and keep it with all previous messages into a forked session. */
  latestMessageId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface HumanReadableQuotaType {
  __typename?: 'HumanReadableQuotaType';
  blobLimit: Scalars['String']['output'];
  copilotActionLimit: Maybe<Scalars['String']['output']>;
  historyPeriod: Scalars['String']['output'];
  memberLimit: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storageQuota: Scalars['String']['output'];
}

export interface InvalidEmailDataType {
  __typename?: 'InvalidEmailDataType';
  email: Scalars['String']['output'];
}

export interface InvalidHistoryTimestampDataType {
  __typename?: 'InvalidHistoryTimestampDataType';
  timestamp: Scalars['String']['output'];
}

export interface InvalidPasswordLengthDataType {
  __typename?: 'InvalidPasswordLengthDataType';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
}

export interface InvalidRuntimeConfigTypeDataType {
  __typename?: 'InvalidRuntimeConfigTypeDataType';
  get: Scalars['String']['output'];
  key: Scalars['String']['output'];
  want: Scalars['String']['output'];
}

export interface InvitationType {
  __typename?: 'InvitationType';
  /** Invitee information */
  invitee: UserType;
  /** User information */
  user: UserType;
  /** Workspace information */
  workspace: InvitationWorkspaceType;
}

export interface InvitationWorkspaceType {
  __typename?: 'InvitationWorkspaceType';
  /** Base64 encoded avatar */
  avatar: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Workspace name */
  name: Scalars['String']['output'];
}

export interface InviteLink {
  __typename?: 'InviteLink';
  /** Invite link expire time */
  expireTime: Scalars['DateTime']['output'];
  /** Invite link */
  link: Scalars['String']['output'];
}

export interface InviteResult {
  __typename?: 'InviteResult';
  email: Scalars['String']['output'];
  /** Invite id, null if invite record create failed */
  inviteId: Maybe<Scalars['String']['output']>;
  /** Invite email sent success */
  sentSuccess: Scalars['Boolean']['output'];
}

export interface InviteToDiscussionGroupInput {
  groupId: Scalars['String']['input'];
  /** 要邀请的用户ID列表 */
  userIds: Array<Scalars['String']['input']>;
}

export interface InviteUserType {
  __typename?: 'InviteUserType';
  /**
   * User accepted
   * @deprecated Use `status` instead
   */
  accepted: Scalars['Boolean']['output'];
  /** User avatar url */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /**
   * User email verified
   * @deprecated useless
   */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** User email */
  email: Maybe<Scalars['String']['output']>;
  /** User email verified */
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  /** User password has been set */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  introduction: Maybe<Scalars['String']['output']>;
  /** Invite id */
  inviteId: Scalars['String']['output'];
  /** User name */
  name: Maybe<Scalars['String']['output']>;
  /** User permission in workspace */
  permission: Permission;
  pointLevel: Maybe<Scalars['Int']['output']>;
  professionalFields: Maybe<Array<Scalars['String']['output']>>;
  securityLevel: Maybe<Scalars['String']['output']>;
  /** Member invite status in workspace */
  status: WorkspaceMemberStatus;
  userTaskPermission: Maybe<Scalars['String']['output']>;
}

export enum InvoiceStatus {
  Draft = 'Draft',
  Open = 'Open',
  Paid = 'Paid',
  Uncollectible = 'Uncollectible',
  Void = 'Void',
}

export interface InvoiceType {
  __typename?: 'InvoiceType';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** @deprecated removed */
  id: Maybe<Scalars['String']['output']>;
  lastPaymentError: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  /** @deprecated removed */
  plan: Maybe<SubscriptionPlan>;
  reason: Scalars['String']['output'];
  /** @deprecated removed */
  recurring: Maybe<SubscriptionRecurring>;
  status: InvoiceStatus;
  updatedAt: Scalars['DateTime']['output'];
}

export interface LimitedUserType {
  __typename?: 'LimitedUserType';
  /** User email */
  email: Scalars['String']['output'];
  /** User password has been set */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
}

export interface ListUserInput {
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface ListedBlob {
  __typename?: 'ListedBlob';
  createdAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  size: Scalars['Int']['output'];
}

export interface ManageUserInput {
  /** User email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User name */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface MemberNotFoundInSpaceDataType {
  __typename?: 'MemberNotFoundInSpaceDataType';
  spaceId: Scalars['String']['output'];
}

export interface MessageListInput {
  groupId: Scalars['String']['input'];
  /** 搜索关键词 */
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}

/** Message status */
export enum MessageStatus {
  Archived = 'Archived',
  Sent = 'Sent',
}

/** Message type */
export enum MessageType {
  File = 'File',
  Text = 'Text',
}

export interface MissingOauthQueryParameterDataType {
  __typename?: 'MissingOauthQueryParameterDataType';
  name: Scalars['String']['output'];
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptInviteById: Scalars['Boolean']['output'];
  /** Accept a submitted task */
  acceptSubmittedTask: TaskType;
  /** Accept a task */
  acceptTask: TaskType;
  addWorkspaceFeature: Scalars['Int']['output'];
  approveMember: Scalars['String']['output'];
  /** Assign task to another user */
  assignTask: AssignmentResult;
  /** Batch assign multiple tasks to a user */
  batchAssignTasks: BatchAssignmentResult;
  cancelSubscription: SubscriptionType;
  /** Cancel a task and its subtasks */
  cancelTask: TaskType;
  changeEmail: UserType;
  changePassword: Scalars['Boolean']['output'];
  /** Cleanup sessions */
  cleanupCopilotSession: Array<Scalars['String']['output']>;
  /** Complete a task */
  completeTask: TaskType;
  /** compute_contributions using AI */
  compute_contributions: Compute_ContributionsResult;
  /** Create change password url */
  createChangePasswordUrl: Scalars['String']['output'];
  /** Create a subscription checkout link of stripe */
  createCheckoutSession: Scalars['String']['output'];
  /** Create a chat message */
  createCopilotMessage: Scalars['String']['output'];
  /** Create a copilot prompt */
  createCopilotPrompt: CopilotPromptType;
  /** Create a chat session */
  createCopilotSession: Scalars['String']['output'];
  /** Create a stripe customer portal to manage payment methods */
  createCustomerPortal: Scalars['String']['output'];
  /** 创建讨论组（聊天话题） */
  createDiscussionGroup: Scalars['String']['output'];
  /** 创建文档模板 */
  createDocumentTemplate: DocumentTemplateResult;
  createInviteLink: InviteLink;
  /** Create a new task with optional subtasks or update existing task */
  createTask: TaskType;
  /** Create a new user */
  createUser: UserType;
  /** Create a new workspace */
  createWorkspace: WorkspaceType;
  deleteAccount: DeleteAccount;
  deleteBlob: Scalars['Boolean']['output'];
  /** 删除文档模板 */
  deleteDocumentTemplate: DeleteTemplateResult;
  /** Delete a task */
  deleteTask: Scalars['Boolean']['output'];
  /** Delete a user account */
  deleteUser: DeleteAccount;
  deleteWorkspace: Scalars['Boolean']['output'];
  /** 解散讨论组（保留消息记录） */
  dissolveDiscussionGroup: Scalars['String']['output'];
  /** Create a chat session */
  forkCopilotSession: Scalars['String']['output'];
  genhistory: Scalars['DateTime']['output'];
  grantMember: Scalars['String']['output'];
  invite: Scalars['String']['output'];
  inviteBatch: Array<InviteResult>;
  /** 邀请用户加入讨论组 */
  inviteToDiscussionGroup: Scalars['String']['output'];
  leaveWorkspace: Scalars['Boolean']['output'];
  publishPage: WorkspacePage;
  recoverDoc: Scalars['DateTime']['output'];
  /** Reject a submitted task */
  rejectSubmittedTask: TaskType;
  /** Reject a task */
  rejectTask: TaskType;
  releaseDeletedBlobs: Scalars['Boolean']['output'];
  /** Remove user avatar */
  removeAvatar: RemoveAvatar;
  /** 移除讨论组成员 */
  removeMemberFromDiscussionGroup: Scalars['String']['output'];
  removeWorkspaceFeature: Scalars['Int']['output'];
  /** Respond to task assignment (accept/reject) */
  respondToAssignment: Scalars['Boolean']['output'];
  resumeSubscription: SubscriptionType;
  revoke: Scalars['Boolean']['output'];
  revokeInviteLink: Scalars['Boolean']['output'];
  /** @deprecated use revokePublicPage */
  revokePage: Scalars['Boolean']['output'];
  revokePublicPage: WorkspacePage;
  sendChangeEmail: Scalars['Boolean']['output'];
  sendChangePasswordEmail: Scalars['Boolean']['output'];
  /** 发送消息 */
  sendDiscussionMessage: Scalars['String']['output'];
  sendSetPasswordEmail: Scalars['Boolean']['output'];
  sendVerifyChangeEmail: Scalars['Boolean']['output'];
  sendVerifyEmail: Scalars['Boolean']['output'];
  setBlob: Scalars['String']['output'];
  setWorkspaceExperimentalFeature: Scalars['Boolean']['output'];
  /** @deprecated renamed to publishPage */
  sharePage: Scalars['Boolean']['output'];
  /** Submit a task */
  submitTask: TaskType;
  /** Summarize an article using AI */
  summarizeArticle: ArticleSummaryResult;
  /** Update a copilot prompt */
  updateCopilotPrompt: CopilotPromptType;
  /** 更新文档模板 */
  updateDocumentTemplate: DocumentTemplateResult;
  updateProfile: UserType;
  /** update server runtime configurable setting */
  updateRuntimeConfig: ServerRuntimeConfigType;
  /** update multiple server runtime configurable settings */
  updateRuntimeConfigs: Array<ServerRuntimeConfigType>;
  updateSubscriptionRecurring: SubscriptionType;
  /** Update an existing task */
  updateTask: TaskType;
  /** Update a user */
  updateUser: UserType;
  /** update user enabled feature */
  updateUserFeatures: Array<FeatureType>;
  /** Update workspace */
  updateWorkspace: WorkspaceType;
  /** Upload user avatar */
  uploadAvatar: UserType;
  verifyEmail: Scalars['Boolean']['output'];
}

export interface MutationAcceptInviteByIdArgs {
  inviteId: Scalars['String']['input'];
  sendAcceptMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationAcceptSubmittedTaskArgs {
  id: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
}

export interface MutationAcceptTaskArgs {
  acceptanceNote?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAddWorkspaceFeatureArgs {
  feature: FeatureType;
  workspaceId: Scalars['String']['input'];
}

export interface MutationApproveMemberArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationAssignTaskArgs {
  input: AssignTaskInput;
}

export interface MutationBatchAssignTasksArgs {
  input: BatchAssignTaskInput;
}

export interface MutationCancelSubscriptionArgs {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<SubscriptionPlan>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationCancelTaskArgs {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export interface MutationChangeEmailArgs {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface MutationChangePasswordArgs {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationCleanupCopilotSessionArgs {
  options: DeleteSessionInput;
}

export interface MutationCompleteTaskArgs {
  completionNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export interface MutationCompute_ContributionsArgs {
  input: Compute_ContributionsInput;
}

export interface MutationCreateChangePasswordUrlArgs {
  callbackUrl: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationCreateCheckoutSessionArgs {
  input: CreateCheckoutSessionInput;
}

export interface MutationCreateCopilotMessageArgs {
  options: CreateChatMessageInput;
}

export interface MutationCreateCopilotPromptArgs {
  input: CreateCopilotPromptInput;
}

export interface MutationCreateCopilotSessionArgs {
  options: CreateChatSessionInput;
}

export interface MutationCreateDiscussionGroupArgs {
  input: CreateDiscussionGroupInput;
}

export interface MutationCreateDocumentTemplateArgs {
  input: CreateDocumentTemplateInput;
}

export interface MutationCreateInviteLinkArgs {
  expireTime: WorkspaceInviteLinkExpireTime;
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateTaskArgs {
  input: CreateTaskInput;
}

export interface MutationCreateUserArgs {
  input: CreateUserInput;
}

export interface MutationCreateWorkspaceArgs {
  init?: InputMaybe<Scalars['Upload']['input']>;
}

export interface MutationDeleteBlobArgs {
  hash?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  permanently?: Scalars['Boolean']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteDocumentTemplateArgs {
  id: Scalars['String']['input'];
}

export interface MutationDeleteTaskArgs {
  id: Scalars['ID']['input'];
}

export interface MutationDeleteUserArgs {
  id: Scalars['String']['input'];
}

export interface MutationDeleteWorkspaceArgs {
  id: Scalars['String']['input'];
}

export interface MutationDissolveDiscussionGroupArgs {
  groupId: Scalars['String']['input'];
}

export interface MutationForkCopilotSessionArgs {
  options: ForkChatSessionInput;
}

export interface MutationGenhistoryArgs {
  guid: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationGrantMemberArgs {
  permission: Permission;
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationInviteArgs {
  email: Scalars['String']['input'];
  permission: Permission;
  sendInviteMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationInviteBatchArgs {
  emails: Array<Scalars['String']['input']>;
  sendInviteMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationInviteToDiscussionGroupArgs {
  input: InviteToDiscussionGroupInput;
}

export interface MutationLeaveWorkspaceArgs {
  sendLeaveMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
  workspaceName?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationPublishPageArgs {
  mode?: InputMaybe<PublicPageMode>;
  pageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRecoverDocArgs {
  guid: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRejectSubmittedTaskArgs {
  id: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
}

export interface MutationRejectTaskArgs {
  id: Scalars['ID']['input'];
  rejectionNote?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationReleaseDeletedBlobsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemoveMemberFromDiscussionGroupArgs {
  input: RemoveMemberFromDiscussionGroupInput;
}

export interface MutationRemoveWorkspaceFeatureArgs {
  feature: FeatureType;
  workspaceId: Scalars['String']['input'];
}

export interface MutationRespondToAssignmentArgs {
  input: RespondAssignmentInput;
}

export interface MutationResumeSubscriptionArgs {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<SubscriptionPlan>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRevokeArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeInviteLinkArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokePageArgs {
  pageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokePublicPageArgs {
  pageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSendChangeEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendChangePasswordEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendDiscussionMessageArgs {
  input: SendMessageInput;
}

export interface MutationSendSetPasswordEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendVerifyChangeEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface MutationSendVerifyEmailArgs {
  callbackUrl: Scalars['String']['input'];
}

export interface MutationSetBlobArgs {
  blob: Scalars['Upload']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetWorkspaceExperimentalFeatureArgs {
  enable: Scalars['Boolean']['input'];
  feature: FeatureType;
  workspaceId: Scalars['String']['input'];
}

export interface MutationSharePageArgs {
  pageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSubmitTaskArgs {
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  submissionNote?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSummarizeArticleArgs {
  input: ArticleSummaryInput;
}

export interface MutationUpdateCopilotPromptArgs {
  messages: Array<CopilotPromptMessageInput>;
  name: Scalars['String']['input'];
}

export interface MutationUpdateDocumentTemplateArgs {
  input: UpdateDocumentTemplateInput;
}

export interface MutationUpdateProfileArgs {
  input: UpdateUserInput;
}

export interface MutationUpdateRuntimeConfigArgs {
  id: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}

export interface MutationUpdateRuntimeConfigsArgs {
  updates: Scalars['JSONObject']['input'];
}

export interface MutationUpdateSubscriptionRecurringArgs {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<SubscriptionPlan>;
  recurring: SubscriptionRecurring;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpdateTaskArgs {
  input: UpdateTaskInput;
}

export interface MutationUpdateUserArgs {
  id: Scalars['String']['input'];
  input: ManageUserInput;
}

export interface MutationUpdateUserFeaturesArgs {
  features: Array<FeatureType>;
  id: Scalars['String']['input'];
}

export interface MutationUpdateWorkspaceArgs {
  input: UpdateWorkspaceInput;
}

export interface MutationUploadAvatarArgs {
  avatar: Scalars['Upload']['input'];
}

export interface MutationVerifyEmailArgs {
  token: Scalars['String']['input'];
}

export interface NestedTaskInput {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface NestedUserInput {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface NotInSpaceDataType {
  __typename?: 'NotInSpaceDataType';
  spaceId: Scalars['String']['output'];
}

export enum OAuthProviderType {
  GitHub = 'GitHub',
  Google = 'Google',
  OIDC = 'OIDC',
  OSREDM = 'OSREDM',
}

export interface PasswordLimitsType {
  __typename?: 'PasswordLimitsType';
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
}

/** User permission in workspace */
export enum Permission {
  Admin = 'Admin',
  Owner = 'Owner',
  Read = 'Read',
  Write = 'Write',
}

/** The mode which the public page default in */
export enum PublicPageMode {
  Edgeless = 'Edgeless',
  Page = 'Page',
}

export interface Query {
  __typename?: 'Query';
  /** @deprecated use `user.quotaUsage` instead */
  collectAllBlobSizes: WorkspaceBlobSizes;
  /** Get current user */
  currentUser: Maybe<UserType>;
  /** 获取用户的讨论组列表 */
  discussionGroups: Scalars['String']['output'];
  /** 获取讨论组的消息历史（七天内） */
  discussionMessages: Scalars['String']['output'];
  /** 获取模板详情 */
  documentTemplate: DocumentTemplateType;
  /** 获取用户的模板列表 */
  documentTemplates: DocumentTemplateListResult;
  /** 根据文档ID获取模板信息 */
  documentTemplatesByDocumentId: DocumentTemplateInfoResult;
  error: ErrorDataUnion;
  /** send workspace invitation */
  getInviteInfo: InvitationType;
  /** Get tasks by document IDs */
  getTaskByDocumentId: Array<DocumentTaskResult>;
  /** 根据工作空间ID和文档ID查询模板ID，如果不是模板则返回空 */
  getTemplateIdByWorkspaceAndDoc: Maybe<Scalars['String']['output']>;
  /** Get is admin of workspace */
  isAdmin: Scalars['Boolean']['output'];
  /** Get is owner of workspace */
  isOwner: Scalars['Boolean']['output'];
  /**
   * List blobs of workspace
   * @deprecated use `workspace.blobs` instead
   */
  listBlobs: Array<Scalars['String']['output']>;
  /** List all copilot prompts */
  listCopilotPrompts: Array<CopilotPromptType>;
  listWorkspaceFeatures: Array<WorkspaceType>;
  /** Get tasks assigned to current user */
  myAssignedTasks: TaskListResult;
  /** Get tasks created by current user */
  myCreatedTasks: TaskListResult;
  /** Get task assignments received by current user */
  myTaskAssignments: TaskListResult;
  /** Get task statistics for current user */
  myTaskStats: TaskStatsResult;
  prices: Array<SubscriptionPrice>;
  /** Get all public tasks (mainly subtasks) across all workspaces */
  publicTasks: TaskListResult;
  /** 查询所有子任务列表（支持 completionNote 模糊查询、分页），返回 workspaceId、documentId、completionNote 等字段 */
  queryAllSubtasks: Array<TaskType>;
  /** Search users by email pattern */
  searchUsers: Array<UserType>;
  /** server config */
  serverConfig: ServerConfigType;
  /** get all server runtime configurable settings */
  serverRuntimeConfig: Array<ServerRuntimeConfigType>;
  serverServiceConfigs: Array<ServerServiceConfig>;
  /** Get a single task by ID */
  task: TaskType;
  /** Get tasks list with filters */
  tasks: TaskListResult;
  /** Get user by email */
  user: Maybe<UserOrLimitedUser>;
  /** Get user by email for admin */
  userByEmail: Maybe<UserType>;
  /** Get user by id */
  userById: UserType;
  /** Get user task and points summary */
  userTaskSummary: UserTaskSummary;
  /** List registered users */
  users: Array<UserType>;
  /** Get users count */
  usersCount: Scalars['Int']['output'];
  /** Get workspace by id */
  workspace: WorkspaceType;
  /** Get all accessible workspaces for current user */
  workspaces: Array<WorkspaceType>;
}

export interface QueryDiscussionGroupsArgs {
  input: DiscussionGroupListInput;
}

export interface QueryDiscussionMessagesArgs {
  input: MessageListInput;
}

export interface QueryDocumentTemplateArgs {
  id: Scalars['String']['input'];
}

export interface QueryDocumentTemplatesArgs {
  input: DocumentTemplateListInput;
}

export interface QueryDocumentTemplatesByDocumentIdArgs {
  documentId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryErrorArgs {
  name: ErrorNames;
}

export interface QueryGetInviteInfoArgs {
  inviteId: Scalars['String']['input'];
}

export interface QueryGetTaskByDocumentIdArgs {
  input: DocumentTaskQueryInput;
}

export interface QueryGetTemplateIdByWorkspaceAndDocArgs {
  documentId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryIsAdminArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryIsOwnerArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryListBlobsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryListWorkspaceFeaturesArgs {
  feature: FeatureType;
}

export interface QueryMyAssignedTasksArgs {
  input: TaskListInput;
}

export interface QueryMyCreatedTasksArgs {
  input: TaskListInput;
}

export interface QueryMyTaskAssignmentsArgs {
  input: TaskListInput;
}

export interface QueryMyTaskStatsArgs {
  input?: InputMaybe<TaskStatsInput>;
}

export interface QueryPublicTasksArgs {
  input: TaskListInput;
}

export interface QueryQueryAllSubtasksArgs {
  input: QuerySubtasksInput;
}

export interface QuerySearchUsersArgs {
  input: SearchUserInput;
}

export interface QueryTaskArgs {
  id: Scalars['ID']['input'];
}

export interface QueryTasksArgs {
  input: TaskListInput;
}

export interface QueryUserArgs {
  email: Scalars['String']['input'];
}

export interface QueryUserByEmailArgs {
  email: Scalars['String']['input'];
}

export interface QueryUserByIdArgs {
  id: Scalars['String']['input'];
}

export interface QueryUserTaskSummaryArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryUsersArgs {
  filter: ListUserInput;
}

export interface QueryWorkspaceArgs {
  id: Scalars['String']['input'];
}

export interface QueryChatHistoriesInput {
  action?: InputMaybe<Scalars['Boolean']['input']>;
  fork?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageOrder?: InputMaybe<ChatHistoryOrder>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sessionOrder?: InputMaybe<ChatHistoryOrder>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface QuerySubtasksInput {
  /** 子任务完成备注模糊查询（支持部分匹配） */
  completionNote?: InputMaybe<Scalars['String']['input']>;
  /** 当前页码，默认1 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 每页条数，默认20，最大100 */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}

export interface QuotaQueryType {
  __typename?: 'QuotaQueryType';
  blobLimit: Scalars['SafeInt']['output'];
  copilotActionLimit: Maybe<Scalars['SafeInt']['output']>;
  historyPeriod: Scalars['SafeInt']['output'];
  humanReadable: HumanReadableQuotaType;
  memberCount: Scalars['SafeInt']['output'];
  memberLimit: Scalars['SafeInt']['output'];
  name: Scalars['String']['output'];
  storageQuota: Scalars['SafeInt']['output'];
  usedSize: Scalars['SafeInt']['output'];
}

export interface RemoveAvatar {
  __typename?: 'RemoveAvatar';
  success: Scalars['Boolean']['output'];
}

export interface RemoveMemberFromDiscussionGroupInput {
  groupId: Scalars['String']['input'];
  /** 要移除的用户ID */
  userId: Scalars['String']['input'];
}

export interface RespondAssignmentInput {
  action: AssignmentStatus;
  assignmentId: Scalars['String']['input'];
  responseNote?: InputMaybe<Scalars['String']['input']>;
}

export interface RuntimeConfigNotFoundDataType {
  __typename?: 'RuntimeConfigNotFoundDataType';
  key: Scalars['String']['output'];
}

export enum RuntimeConfigType {
  Array = 'Array',
  Boolean = 'Boolean',
  Number = 'Number',
  Object = 'Object',
  String = 'String',
}

export interface SameSubscriptionRecurringDataType {
  __typename?: 'SameSubscriptionRecurringDataType';
  recurring: Scalars['String']['output'];
}

export interface SearchUserInput {
  email: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface SendMessageInput {
  content: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  groupId: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  type?: MessageType;
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface ServerConfigType {
  __typename?: 'ServerConfigType';
  /** Features for user that can be configured */
  availableUserFeatures: Array<FeatureType>;
  /** server base url */
  baseUrl: Scalars['String']['output'];
  /** credentials requirement */
  credentialsRequirement: CredentialsRequirementType;
  /** enable telemetry */
  enableTelemetry: Scalars['Boolean']['output'];
  /** enabled server features */
  features: Array<ServerFeature>;
  /** server flags */
  flags: ServerFlagsType;
  /**
   * server flavor
   * @deprecated use `features`
   */
  flavor: Scalars['String']['output'];
  /** whether server has been initialized */
  initialized: Scalars['Boolean']['output'];
  /** server identical name could be shown as badge on user interface */
  name: Scalars['String']['output'];
  oauthProviders: Array<OAuthProviderType>;
  /** server type */
  type: ServerDeploymentType;
  /** server version */
  version: Scalars['String']['output'];
}

export enum ServerDeploymentType {
  Affine = 'Affine',
  Selfhosted = 'Selfhosted',
}

export enum ServerFeature {
  Captcha = 'Captcha',
  Copilot = 'Copilot',
  OAuth = 'OAuth',
  Payment = 'Payment',
}

export interface ServerFlagsType {
  __typename?: 'ServerFlagsType';
  earlyAccessControl: Scalars['Boolean']['output'];
  syncClientVersionCheck: Scalars['Boolean']['output'];
}

export interface ServerRuntimeConfigType {
  __typename?: 'ServerRuntimeConfigType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  module: Scalars['String']['output'];
  type: RuntimeConfigType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['JSON']['output'];
}

export interface ServerServiceConfig {
  __typename?: 'ServerServiceConfig';
  config: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
}

export interface SpaceAccessDeniedDataType {
  __typename?: 'SpaceAccessDeniedDataType';
  spaceId: Scalars['String']['output'];
}

export interface SpaceNotFoundDataType {
  __typename?: 'SpaceNotFoundDataType';
  spaceId: Scalars['String']['output'];
}

export interface SpaceOwnerNotFoundDataType {
  __typename?: 'SpaceOwnerNotFoundDataType';
  spaceId: Scalars['String']['output'];
}

export interface SubscriptionAlreadyExistsDataType {
  __typename?: 'SubscriptionAlreadyExistsDataType';
  plan: Scalars['String']['output'];
}

export interface SubscriptionNotExistsDataType {
  __typename?: 'SubscriptionNotExistsDataType';
  plan: Scalars['String']['output'];
}

export enum SubscriptionPlan {
  AI = 'AI',
  Enterprise = 'Enterprise',
  Free = 'Free',
  Pro = 'Pro',
  SelfHosted = 'SelfHosted',
  Team = 'Team',
}

export interface SubscriptionPlanNotFoundDataType {
  __typename?: 'SubscriptionPlanNotFoundDataType';
  plan: Scalars['String']['output'];
  recurring: Scalars['String']['output'];
}

export interface SubscriptionPrice {
  __typename?: 'SubscriptionPrice';
  amount: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  lifetimeAmount: Maybe<Scalars['Int']['output']>;
  plan: SubscriptionPlan;
  type: Scalars['String']['output'];
  yearlyAmount: Maybe<Scalars['Int']['output']>;
}

export enum SubscriptionRecurring {
  Lifetime = 'Lifetime',
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}

export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid',
}

export interface SubscriptionType {
  __typename?: 'SubscriptionType';
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  end: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated removed */
  id: Maybe<Scalars['String']['output']>;
  nextBillAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * The 'Free' plan just exists to be a placeholder and for the type convenience of frontend.
   * There won't actually be a subscription with plan 'Free'
   */
  plan: SubscriptionPlan;
  recurring: SubscriptionRecurring;
  start: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  trialEnd: Maybe<Scalars['DateTime']['output']>;
  trialStart: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variant: Maybe<SubscriptionVariant>;
}

export enum SubscriptionVariant {
  EA = 'EA',
  Onetime = 'Onetime',
}

export interface TaskAssignmentRecordType {
  __typename?: 'TaskAssignmentRecordType';
  assignedAt: Scalars['DateTime']['output'];
  assignedBy: Scalars['String']['output'];
  assignedByUser: UserType;
  /** Assignment type: Manual, Public, or Invited */
  assignmentType: Scalars['String']['output'];
  /** Completed at */
  completedAt: Maybe<Scalars['DateTime']['output']>;
  /** Completion note */
  completionNote: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Associated document ID */
  documentId: Maybe<Scalars['String']['output']>;
  /** Associated document URL */
  documentUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Points awarded */
  points: Scalars['Int']['output'];
  /** Whether points are paid */
  pointsPaid: Scalars['Boolean']['output'];
  /** Points paid at */
  pointsPaidAt: Maybe<Scalars['DateTime']['output']>;
  /** Rejection reason */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Reviewed at */
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  reviewer: Maybe<UserType>;
  /** Reviewer ID */
  reviewerId: Maybe<Scalars['String']['output']>;
  /** Task status for this assignment */
  status: TaskStatus;
  /** Submitted at */
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  task: TaskType;
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  /** User or group information based on userId and userType */
  userInfo: Maybe<UserType>;
  /** User type: Individual or Group */
  userType: Scalars['String']['output'];
}

export interface TaskAssignmentType {
  __typename?: 'TaskAssignmentType';
  assignedAt: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  fromUser: Maybe<UserType>;
  fromUserId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Maybe<Scalars['String']['output']>;
  respondedAt: Maybe<Scalars['DateTime']['output']>;
  responseNote: Maybe<Scalars['String']['output']>;
  status: AssignmentStatus;
  task: TaskType;
  taskId: Scalars['String']['output'];
  toUser: UserType;
  toUserId: Scalars['String']['output'];
}

export interface TaskDependencyType {
  __typename?: 'TaskDependencyType';
  createdAt: Scalars['DateTime']['output'];
  dependsOn: TaskType;
  dependsOnId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  task: TaskType;
  taskId: Scalars['String']['output'];
}

export interface TaskFilterInput {
  creatorId?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TaskPriority>;
  status?: InputMaybe<TaskStatus>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface TaskListInput {
  filter?: InputMaybe<TaskFilterInput>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}

export interface TaskListResult {
  __typename?: 'TaskListResult';
  list: Array<TaskType>;
  total: Scalars['Int']['output'];
}

/** Task permission type */
export enum TaskPermissionEnum {
  Edit = 'Edit',
  View = 'View',
}

export interface TaskPermissionInput {
  permission: TaskPermissionEnum;
  userId: Scalars['String']['input'];
}

export interface TaskPermissionType {
  __typename?: 'TaskPermissionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  permission: TaskPermissionEnum;
  task: TaskType;
  taskId: Scalars['String']['output'];
  user: UserType;
  userId: Scalars['String']['output'];
}

/** Task priority level */
export enum TaskPriority {
  High = 'High',
  Low = 'Low',
  Normal = 'Normal',
  Urgent = 'Urgent',
}

export interface TaskStatsInput {
  /** Filter by task status */
  status?: InputMaybe<TaskStatus>;
  /** Filter by workspace ID */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface TaskStatsResult {
  __typename?: 'TaskStatsResult';
  /** Number of tasks assigned to current user */
  assignedCount: Scalars['Int']['output'];
  /** Number of tasks created by current user */
  createdCount: Scalars['Int']['output'];
  /** Number of pending task assignments for current user */
  pendingAssignmentCount: Scalars['Int']['output'];
}

/** Task status */
export enum TaskStatus {
  /** 已采纳 */
  Accepted = 'Accepted',
  /** 已取消 */
  Cancelled = 'Cancelled',
  /** 已完成 */
  Completed = 'Completed',
  /** 处理中 */
  InProgress = 'InProgress',
  /** 待分配 */
  PendingAssignment = 'PendingAssignment',
  /** 已拒绝 */
  Rejected = 'Rejected',
  /** 已提交 */
  Submitted = 'Submitted',
  /** 待处理 */
  Todo = 'Todo',
}

export interface TaskType {
  __typename?: 'TaskType';
  /** Task assignment records */
  assignmentRecords: Array<TaskAssignmentRecordType>;
  assignments: Array<TaskAssignmentType>;
  completedAt: Maybe<Scalars['DateTime']['output']>;
  completionNote: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator: UserType;
  creatorId: Scalars['String']['output'];
  deadline: Maybe<Scalars['DateTime']['output']>;
  dependencies: Array<TaskDependencyType>;
  description: Maybe<Scalars['String']['output']>;
  /** Associated discussion groups */
  discussionGroups: Array<DiscussionGroupType>;
  /** Associated document ID */
  documentId: Maybe<Scalars['String']['output']>;
  /** Associated document URL */
  documentUrl: Maybe<Scalars['String']['output']>;
  /** Associated discussion group IDs array */
  groupIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the task is public (only applies to subtasks) */
  isPublic: Scalars['Boolean']['output'];
  /** Current user's assignment record for this task */
  myAssignmentRecord: Maybe<TaskAssignmentRecordType>;
  name: Scalars['String']['output'];
  owner: Maybe<UserType>;
  ownerId: Maybe<Scalars['String']['output']>;
  /** Multiple owner IDs array */
  ownerIds: Array<Scalars['String']['output']>;
  /** Multiple task owners */
  owners: Array<UserType>;
  parent: Maybe<TaskType>;
  parentId: Maybe<Scalars['ID']['output']>;
  permissions: Array<TaskPermissionType>;
  /** Task points reward */
  points: Scalars['Int']['output'];
  priority: TaskPriority;
  /** Rejection reason when task is rejected */
  rejectionReason: Maybe<Scalars['String']['output']>;
  status: TaskStatus;
  subtasks: Array<TaskType>;
  /** Task type: 1-OutlineCollection, 2-ContentWriting */
  taskType: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface UnknownOauthProviderDataType {
  __typename?: 'UnknownOauthProviderDataType';
  name: Scalars['String']['output'];
}

export interface UnsupportedSubscriptionPlanDataType {
  __typename?: 'UnsupportedSubscriptionPlanDataType';
  plan: Scalars['String']['output'];
}

export interface UpdateDocumentTemplateInput {
  documentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateSubtaskInput {
  completionNote?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Associated document ID */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Associated document URL */
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Associated discussion group IDs array */
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the subtask is public */
  isPublic?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** Multiple owner IDs array */
  ownerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  permissions?: InputMaybe<Array<TaskPermissionInput>>;
  /** Points reward for completing this subtask */
  points?: Scalars['Int']['input'];
  priority?: TaskPriority;
  status?: InputMaybe<TaskStatus>;
  /** Task type: 1-OutlineCollection, 2-ContentWriting */
  taskType?: Scalars['Int']['input'];
}

export interface UpdateTaskInput {
  completionNote?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Associated document ID */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Associated document URL */
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Associated discussion group IDs array */
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  /** Whether the task is public (only applies to subtasks) */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Multiple owner IDs array */
  ownerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Points reward for completing this task */
  points?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<TaskPriority>;
  status?: InputMaybe<TaskStatus>;
  /** Complete list of subtasks. Missing subtasks will be deleted, subtasks without id will be created. */
  subtasks?: InputMaybe<Array<UpdateSubtaskInput>>;
  /** Task type: 1-OutlineCollection, 2-ContentWriting */
  taskType?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpdateUserInput {
  /** User name */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateWorkspaceInput {
  /** Enable AI */
  enableAi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable url previous when sharing */
  enableUrlPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** is Public workspace */
  public?: InputMaybe<Scalars['Boolean']['input']>;
}

export type UserOrLimitedUser = LimitedUserType | UserType;

export interface UserQuota {
  __typename?: 'UserQuota';
  blobLimit: Scalars['SafeInt']['output'];
  historyPeriod: Scalars['SafeInt']['output'];
  humanReadable: UserQuotaHumanReadable;
  memberLimit: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storageQuota: Scalars['SafeInt']['output'];
}

export interface UserQuotaHumanReadable {
  __typename?: 'UserQuotaHumanReadable';
  blobLimit: Scalars['String']['output'];
  historyPeriod: Scalars['String']['output'];
  memberLimit: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storageQuota: Scalars['String']['output'];
}

export interface UserQuotaUsage {
  __typename?: 'UserQuotaUsage';
  storageQuota: Scalars['SafeInt']['output'];
}

export interface UserTaskSummary {
  __typename?: 'UserTaskSummary';
  /** 发布任务数量（主任务） */
  createdTasksCount: Scalars['Int']['output'];
  /** 我的任务数量（主任务+子任务） */
  myTasksCount: Scalars['Int']['output'];
  /** 积分余额 */
  pointsBalance: Scalars['Int']['output'];
}

export interface UserType {
  __typename?: 'UserType';
  /** User avatar url */
  avatarUrl: Maybe<Scalars['String']['output']>;
  copilot: Copilot;
  /**
   * User email verified
   * @deprecated useless
   */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** User email */
  email: Scalars['String']['output'];
  /** User email verified */
  emailVerified: Scalars['Boolean']['output'];
  /** Enabled features of a user */
  features: Array<FeatureType>;
  /** User password has been set */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  introduction: Maybe<Scalars['String']['output']>;
  /** Get user invoice count */
  invoiceCount: Scalars['Int']['output'];
  invoices: Array<InvoiceType>;
  /** User name */
  name: Scalars['String']['output'];
  pointLevel: Maybe<Scalars['Int']['output']>;
  professionalFields: Maybe<Array<Scalars['String']['output']>>;
  quota: Maybe<UserQuota>;
  quotaUsage: UserQuotaUsage;
  securityLevel: Maybe<Scalars['String']['output']>;
  subscriptions: Array<SubscriptionType>;
  /** @deprecated use [/api/auth/sign-in?native=true] instead */
  token: TokenType;
  userTaskPermission: Maybe<Scalars['String']['output']>;
}

export interface UserTypeCopilotArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface UserTypeInvoicesArgs {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface VersionRejectedDataType {
  __typename?: 'VersionRejectedDataType';
  serverVersion: Scalars['String']['output'];
  version: Scalars['String']['output'];
}

export interface WorkspaceBlobSizes {
  __typename?: 'WorkspaceBlobSizes';
  size: Scalars['SafeInt']['output'];
}

/** Workspace invite link expire time */
export enum WorkspaceInviteLinkExpireTime {
  OneDay = 'OneDay',
  OneMonth = 'OneMonth',
  OneWeek = 'OneWeek',
  ThreeDays = 'ThreeDays',
}

/** Member invite status in workspace */
export enum WorkspaceMemberStatus {
  Accepted = 'Accepted',
  NeedMoreSeat = 'NeedMoreSeat',
  NeedMoreSeatAndReview = 'NeedMoreSeatAndReview',
  Pending = 'Pending',
  UnderReview = 'UnderReview',
}

export interface WorkspacePage {
  __typename?: 'WorkspacePage';
  id: Scalars['String']['output'];
  mode: PublicPageMode;
  public: Scalars['Boolean']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface WorkspacePageMeta {
  __typename?: 'WorkspacePageMeta';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<EditorType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<EditorType>;
}

export interface WorkspaceType {
  __typename?: 'WorkspaceType';
  /** Available features of workspace */
  availableFeatures: Array<FeatureType>;
  /** List blobs of workspace */
  blobs: Array<ListedBlob>;
  /** Blobs size of workspace */
  blobsSize: Scalars['Int']['output'];
  /** Workspace created date */
  createdAt: Scalars['DateTime']['output'];
  /** Enable AI */
  enableAi: Scalars['Boolean']['output'];
  /** Enable url previous when sharing */
  enableUrlPreview: Scalars['Boolean']['output'];
  /** Enabled features of workspace */
  features: Array<FeatureType>;
  histories: Array<DocHistoryType>;
  id: Scalars['ID']['output'];
  /** is current workspace initialized */
  initialized: Scalars['Boolean']['output'];
  /** invite link for workspace */
  inviteLink: Maybe<InviteLink>;
  /** Get user invoice count */
  invoiceCount: Scalars['Int']['output'];
  invoices: Array<InvoiceType>;
  /** member count of workspace */
  memberCount: Scalars['Int']['output'];
  /** Members of workspace */
  members: Array<InviteUserType>;
  /** Owner of workspace */
  owner: UserType;
  /** Cloud page metadata of workspace */
  pageMeta: WorkspacePageMeta;
  /** Permission of current signed in user in workspace */
  permission: Permission;
  /** is Public workspace */
  public: Scalars['Boolean']['output'];
  /** Get public page of a workspace by page id. */
  publicPage: Maybe<WorkspacePage>;
  /** Public pages of a workspace */
  publicPages: Array<WorkspacePage>;
  /** quota of workspace */
  quota: QuotaQueryType;
  /**
   * Shared pages of workspace
   * @deprecated use WorkspaceType.publicPages
   */
  sharedPages: Array<Scalars['String']['output']>;
  /** The team subscription of the workspace, if exists. */
  subscription: Maybe<SubscriptionType>;
  /** if workspace is team workspace */
  team: Scalars['Boolean']['output'];
}

export interface WorkspaceTypeHistoriesArgs {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  guid: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceTypeInvoicesArgs {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceTypeMembersArgs {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceTypePageMetaArgs {
  pageId: Scalars['String']['input'];
}

export interface WorkspaceTypePublicPageArgs {
  pageId: Scalars['String']['input'];
}

export interface WrongSignInCredentialsDataType {
  __typename?: 'WrongSignInCredentialsDataType';
  email: Scalars['String']['output'];
}

export interface Compute_ContributionsInput {
  /** 贡献内容 */
  contributions: Array<ContributionEntryInput>;
  /** 融合后的文档 */
  fused_text: Scalars['String']['input'];
}

export interface Compute_ContributionsResult {
  __typename?: 'compute_contributionsResult';
  /** 返回消息 */
  message: Scalars['String']['output'];
  /** 计算结果 */
  res: Maybe<Scalars['String']['output']>;
  /** 计算是否成功 */
  success: Scalars['Boolean']['output'];
}

export interface TokenType {
  __typename?: 'tokenType';
  refresh: Scalars['String']['output'];
  sessionToken: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
}

export type AcceptSubmittedTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
}>;

export type AcceptSubmittedTaskMutation = {
  __typename?: 'Mutation';
  acceptSubmittedTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    description: string | null;
    status: TaskStatus;
    priority: TaskPriority;
    points: number;
    createdAt: string;
    updatedAt: string;
    completedAt: string | null;
    deadline: string | null;
    completionNote: string | null;
    workspaceId: string;
    parentId: string | null;
    creatorId: string;
    ownerIds: Array<string>;
    groupIds: Array<string>;
    documentId: string | null;
    documentUrl: string | null;
    rejectionReason: string | null;
    taskType: number;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
    parent: {
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
    } | null;
  };
};

export type AcceptSubtaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  acceptanceNote?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
}>;

export type AcceptSubtaskMutation = {
  __typename?: 'Mutation';
  acceptTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    status: TaskStatus;
    completionNote: string | null;
    documentId: string | null;
    documentUrl: string | null;
    updatedAt: string;
    owner: { __typename?: 'UserType'; id: string; name: string } | null;
    creator: { __typename?: 'UserType'; id: string; name: string };
    parent: { __typename?: 'TaskType'; id: string; name: string } | null;
  };
};

export type CreateMainTaskWithSubtasksMutationVariables = Exact<{
  input: CreateTaskInput;
}>;

export type CreateMainTaskWithSubtasksMutation = {
  __typename?: 'Mutation';
  createTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    description: string | null;
    points: number;
    creatorId: string;
    ownerId: string | null;
    priority: TaskPriority;
    deadline: string | null;
    status: TaskStatus;
    taskType: number;
    createdAt: string;
    subtasks: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      description: string | null;
      points: number;
      priority: TaskPriority;
      deadline: string | null;
      status: TaskStatus;
      taskType: number;
      creatorId: string;
      ownerId: string | null;
      parentId: string | null;
      owner: { __typename?: 'UserType'; id: string; name: string } | null;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        avatarUrl: string | null;
        email: string;
      };
    }>;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      avatarUrl: string | null;
      email: string;
    };
    owner: { __typename?: 'UserType'; id: string; name: string } | null;
  };
};

export type AdminServerConfigQueryVariables = Exact<{ [key: string]: never }>;

export type AdminServerConfigQuery = {
  __typename?: 'Query';
  serverConfig: {
    __typename?: 'ServerConfigType';
    version: string;
    baseUrl: string;
    name: string;
    features: Array<ServerFeature>;
    type: ServerDeploymentType;
    initialized: boolean;
    availableUserFeatures: Array<FeatureType>;
    credentialsRequirement: {
      __typename?: 'CredentialsRequirementType';
      password: {
        __typename?: 'PasswordLimitsType';
        minLength: number;
        maxLength: number;
      };
    };
  };
};

export type GetAllPublicTasksQueryVariables = Exact<{
  input: TaskListInput;
}>;

export type GetAllPublicTasksQuery = {
  __typename?: 'Query';
  publicTasks: {
    __typename?: 'TaskListResult';
    total: number;
    list: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
      priority: TaskPriority;
      points: number;
      deadline: string | null;
      createdAt: string;
      updatedAt: string;
      completedAt: string | null;
      creatorId: string;
      ownerId: string | null;
      parentId: string | null;
      workspaceId: string;
      description: string | null;
      isPublic: boolean;
      documentId: string | null;
      documentUrl: string | null;
      completionNote: string | null;
      taskType: number;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
      owner: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      parent: {
        __typename?: 'TaskType';
        id: string;
        name: string;
        status: TaskStatus;
        creator: { __typename?: 'UserType'; id: string; name: string };
        owner: { __typename?: 'UserType'; id: string; name: string } | null;
      } | null;
      subtasks: Array<{
        __typename?: 'TaskType';
        id: string;
        name: string;
        description: string | null;
        status: TaskStatus;
        priority: TaskPriority;
        points: number;
        deadline: string | null;
        documentId: string | null;
        documentUrl: string | null;
        completedAt: string | null;
        completionNote: string | null;
        createdAt: string;
        updatedAt: string;
        isPublic: boolean;
        creatorId: string;
        ownerId: string | null;
        parentId: string | null;
        workspaceId: string;
        taskType: number;
        parent: { __typename?: 'TaskType'; id: string; name: string } | null;
        creator: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        owner: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        assignmentRecords: Array<{
          __typename?: 'TaskAssignmentRecordType';
          id: string;
          userId: string;
          taskId: string;
          userType: string;
          assignedBy: string;
          assignedAt: string;
          assignmentType: string;
          status: TaskStatus;
          documentId: string | null;
          documentUrl: string | null;
          completionNote: string | null;
          submittedAt: string | null;
          completedAt: string | null;
          reviewerId: string | null;
          reviewedAt: string | null;
          rejectionReason: string | null;
          points: number;
          pointsPaid: boolean;
          pointsPaidAt: string | null;
          createdAt: string;
          updatedAt: string;
          assignedByUser: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          };
          reviewer: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          } | null;
          userInfo: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          } | null;
        }>;
      }>;
    }>;
  };
};

export type DeleteBlobMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  permanently?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteBlobMutation = {
  __typename?: 'Mutation';
  deleteBlob: boolean;
};

export type ListBlobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ListBlobsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    blobs: Array<{
      __typename?: 'ListedBlob';
      key: string;
      size: number;
      mime: string;
      createdAt: string;
    }>;
  };
};

export type ReleaseDeletedBlobsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ReleaseDeletedBlobsMutation = {
  __typename?: 'Mutation';
  releaseDeletedBlobs: boolean;
};

export type SetBlobMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  blob: Scalars['Upload']['input'];
}>;

export type SetBlobMutation = { __typename?: 'Mutation'; setBlob: string };

export type CancelSingleSubtaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cancellationNote: Scalars['String']['input'];
}>;

export type CancelSingleSubtaskMutation = {
  __typename?: 'Mutation';
  cancelTask: {
    __typename?: 'TaskType';
    id: string;
    status: TaskStatus;
    completionNote: string | null;
    parent: { __typename?: 'TaskType'; id: string; status: TaskStatus } | null;
  };
};

export type CancelMainTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cancellationNote: Scalars['String']['input'];
}>;

export type CancelMainTaskMutation = {
  __typename?: 'Mutation';
  cancelTask: {
    __typename?: 'TaskType';
    id: string;
    status: TaskStatus;
    completionNote: string | null;
    subtasks: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
      assignmentRecords: Array<{
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        taskId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        reviewerId: string | null;
        reviewedAt: string | null;
        rejectionReason: string | null;
        points: number;
        pointsPaid: boolean;
        pointsPaidAt: string | null;
        createdAt: string;
        updatedAt: string;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      }>;
    }>;
  };
};

export type CancelSubscriptionMutationVariables = Exact<{
  plan?: InputMaybe<SubscriptionPlan>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CancelSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelSubscription: {
    __typename?: 'SubscriptionType';
    id: string | null;
    status: SubscriptionStatus;
    nextBillAt: string | null;
    canceledAt: string | null;
  };
};

export type ChangeEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;

export type ChangeEmailMutation = {
  __typename?: 'Mutation';
  changeEmail: { __typename?: 'UserType'; id: string; email: string };
};

export type CreateChangePasswordUrlMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type CreateChangePasswordUrlMutation = {
  __typename?: 'Mutation';
  createChangePasswordUrl: string;
};

export type ChangePasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword: boolean;
};

export type CompleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  completionNote?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompleteTaskMutation = {
  __typename?: 'Mutation';
  completeTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    status: TaskStatus;
    completedAt: string | null;
    completionNote: string | null;
    points: number;
    createdAt: string;
    updatedAt: string;
    creatorId: string;
    ownerId: string | null;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
    parent: {
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
    } | null;
    subtasks: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
      points: number;
      completedAt: string | null;
      ownerId: string | null;
      owner: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      assignmentRecords: Array<{
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        taskId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        reviewerId: string | null;
        reviewedAt: string | null;
        rejectionReason: string | null;
        points: number;
        pointsPaid: boolean;
        pointsPaidAt: string | null;
        createdAt: string;
        updatedAt: string;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      }>;
    }>;
  };
};

export type Compute_ContributionsMutationVariables = Exact<{
  input: Compute_ContributionsInput;
}>;

export type Compute_ContributionsMutation = {
  __typename?: 'Mutation';
  compute_contributions: {
    __typename?: 'compute_contributionsResult';
    success: boolean;
    message: string;
    res: string | null;
  };
};

export type UpdateSubtaskStatusMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;

export type UpdateSubtaskStatusMutation = {
  __typename?: 'Mutation';
  updateTask: {
    __typename?: 'TaskType';
    id: string;
    status: TaskStatus;
    parent: { __typename?: 'TaskType'; id: string; status: TaskStatus } | null;
  };
};

export type CopilotQuotaQueryVariables = Exact<{ [key: string]: never }>;

export type CopilotQuotaQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      quota: {
        __typename?: 'CopilotQuota';
        limit: number | null;
        used: number;
      };
    };
  } | null;
};

export type CleanupCopilotSessionMutationVariables = Exact<{
  input: DeleteSessionInput;
}>;

export type CleanupCopilotSessionMutation = {
  __typename?: 'Mutation';
  cleanupCopilotSession: Array<string>;
};

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;

export type CreateCheckoutSessionMutation = {
  __typename?: 'Mutation';
  createCheckoutSession: string;
};

export type CreateCopilotMessageMutationVariables = Exact<{
  options: CreateChatMessageInput;
}>;

export type CreateCopilotMessageMutation = {
  __typename?: 'Mutation';
  createCopilotMessage: string;
};

export type CreateCopilotSessionMutationVariables = Exact<{
  options: CreateChatSessionInput;
}>;

export type CreateCopilotSessionMutation = {
  __typename?: 'Mutation';
  createCopilotSession: string;
};

export type CreateCustomerPortalMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateCustomerPortalMutation = {
  __typename?: 'Mutation';
  createCustomerPortal: string;
};

export type CreateDiscussionGroupMutationVariables = Exact<{
  input: CreateDiscussionGroupInput;
}>;

export type CreateDiscussionGroupMutation = {
  __typename?: 'Mutation';
  createDiscussionGroup: string;
};

export type CreateDocumentTemplateMutationVariables = Exact<{
  input: CreateDocumentTemplateInput;
}>;

export type CreateDocumentTemplateMutation = {
  __typename?: 'Mutation';
  createDocumentTemplate: {
    __typename?: 'DocumentTemplateResult';
    message: string;
    template: {
      __typename?: 'DocumentTemplateType';
      id: string;
      name: string;
      documentId: string;
      workspaceId: string | null;
      createdBy: string;
      createdAt: string;
      updatedAt: string;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
    };
  };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'UserType'; id: string };
};

export type CreateWorkspaceMutationVariables = Exact<{ [key: string]: never }>;

export type CreateWorkspaceMutation = {
  __typename?: 'Mutation';
  createWorkspace: {
    __typename?: 'WorkspaceType';
    id: string;
    public: boolean;
    createdAt: string;
  };
};

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteAccountMutation = {
  __typename?: 'Mutation';
  deleteAccount: { __typename?: 'DeleteAccount'; success: boolean };
};

export type DeleteDocumentTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteDocumentTemplateMutation = {
  __typename?: 'Mutation';
  deleteDocumentTemplate: {
    __typename?: 'DeleteTemplateResult';
    templateId: string;
    message: string;
  };
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser: { __typename?: 'DeleteAccount'; success: boolean };
};

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteWorkspaceMutation = {
  __typename?: 'Mutation';
  deleteWorkspace: boolean;
};

export type GetDiscussionGroupsQueryVariables = Exact<{
  input: DiscussionGroupListInput;
}>;

export type GetDiscussionGroupsQuery = {
  __typename?: 'Query';
  discussionGroups: string;
};

export type GetDiscussionMessagesQueryVariables = Exact<{
  input: MessageListInput;
}>;

export type GetDiscussionMessagesQuery = {
  __typename?: 'Query';
  discussionMessages: string;
};

export type DissolveDiscussionGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;

export type DissolveDiscussionGroupMutation = {
  __typename?: 'Mutation';
  dissolveDiscussionGroup: string;
};

export type DocumentTemplateDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DocumentTemplateDetailQuery = {
  __typename?: 'Query';
  documentTemplate: {
    __typename?: 'DocumentTemplateType';
    id: string;
    name: string;
    documentId: string;
    workspaceId: string | null;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
  };
};

export type DocumentTemplateInfoByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;

export type DocumentTemplateInfoByDocumentIdQuery = {
  __typename?: 'Query';
  documentTemplatesByDocumentId: {
    __typename?: 'DocumentTemplateInfoResult';
    templateId: string | null;
    templateName: string | null;
    isTemplate: boolean;
  };
};

export type DocumentTemplatesListQueryVariables = Exact<{
  input: DocumentTemplateListInput;
}>;

export type DocumentTemplatesListQuery = {
  __typename?: 'Query';
  documentTemplates: {
    __typename?: 'DocumentTemplateListResult';
    total: number;
    page: number;
    pageSize: number;
    list: Array<{
      __typename?: 'DocumentTemplateType';
      id: string;
      name: string;
      documentId: string;
      workspaceId: string | null;
      createdBy: string;
      createdAt: string;
      updatedAt: string;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
    }>;
  };
};

export type MixedOperationsMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;

export type MixedOperationsMutation = {
  __typename?: 'Mutation';
  updateTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    points: number;
    taskType: number;
    subtasks: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
      points: number;
      taskType: number;
      priority: TaskPriority;
      createdAt: string;
      completedAt: string | null;
      owner: { __typename?: 'UserType'; name: string } | null;
      assignmentRecords: Array<{
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        taskId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        reviewerId: string | null;
        reviewedAt: string | null;
        rejectionReason: string | null;
        points: number;
        pointsPaid: boolean;
        pointsPaidAt: string | null;
        createdAt: string;
        updatedAt: string;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      }>;
    }>;
  };
};

export type ForkCopilotSessionMutationVariables = Exact<{
  options: ForkChatSessionInput;
}>;

export type ForkCopilotSessionMutation = {
  __typename?: 'Mutation';
  forkCopilotSession: string;
};

export type CredentialsRequirementFragment = {
  __typename?: 'CredentialsRequirementType';
  password: {
    __typename?: 'PasswordLimitsType';
    minLength: number;
    maxLength: number;
  };
};

export type PasswordLimitsFragment = {
  __typename?: 'PasswordLimitsType';
  minLength: number;
  maxLength: number;
};

export type GenhistoryMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  guid: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
}>;

export type GenhistoryMutation = {
  __typename?: 'Mutation';
  genhistory: string;
};

export type GetCopilotHistoriesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotHistoriesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      histories: Array<{
        __typename?: 'CopilotHistories';
        sessionId: string;
        tokens: number;
        action: string | null;
        createdAt: string;
        messages: Array<{
          __typename?: 'ChatMessage';
          id: string | null;
          role: string;
          content: string;
          attachments: Array<string> | null;
          createdAt: string;
        }>;
      }>;
    };
  } | null;
};

export type GetCopilotHistoryIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotHistoryIdsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      histories: Array<{
        __typename?: 'CopilotHistories';
        sessionId: string;
        messages: Array<{
          __typename?: 'ChatMessage';
          id: string | null;
          role: string;
          createdAt: string;
        }>;
      }>;
    };
  } | null;
};

export type GetCopilotSessionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetCopilotSessionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      actions: Array<string>;
      chats: Array<string>;
    };
  } | null;
};

export type GetCurrentUserFeaturesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentUserFeaturesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    emailVerified: boolean;
    avatarUrl: string | null;
    features: Array<FeatureType>;
  } | null;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    emailVerified: boolean;
    avatarUrl: string | null;
    token: { __typename?: 'tokenType'; sessionToken: string | null };
  } | null;
};

export type GetDocumentTemplateQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetDocumentTemplateQuery = {
  __typename?: 'Query';
  getTemplateIdByWorkspaceAndDoc: string | null;
};

export type GetInviteInfoQueryVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;

export type GetInviteInfoQuery = {
  __typename?: 'Query';
  getInviteInfo: {
    __typename?: 'InvitationType';
    workspace: {
      __typename?: 'InvitationWorkspaceType';
      id: string;
      name: string;
      avatar: string;
    };
    user: {
      __typename?: 'UserType';
      id: string;
      name: string;
      avatarUrl: string | null;
    };
  };
};

export type GetIsAdminQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetIsAdminQuery = { __typename?: 'Query'; isAdmin: boolean };

export type GetIsOwnerQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetIsOwnerQuery = { __typename?: 'Query'; isOwner: boolean };

export type GetMemberCountByWorkspaceIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetMemberCountByWorkspaceIdQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; memberCount: number };
};

export type GetMembersByWorkspaceIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;

export type GetMembersByWorkspaceIdQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    memberCount: number;
    members: Array<{
      __typename?: 'InviteUserType';
      id: string;
      name: string | null;
      email: string | null;
      avatarUrl: string | null;
      permission: Permission;
      inviteId: string;
      accepted: boolean;
      emailVerified: boolean | null;
      status: WorkspaceMemberStatus;
    }>;
  };
};

export type OauthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type OauthProvidersQuery = {
  __typename?: 'Query';
  serverConfig: {
    __typename?: 'ServerConfigType';
    oauthProviders: Array<OAuthProviderType>;
  };
};

export type GetPromptsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPromptsQuery = {
  __typename?: 'Query';
  listCopilotPrompts: Array<{
    __typename?: 'CopilotPromptType';
    name: string;
    model: string;
    action: string | null;
    config: {
      __typename?: 'CopilotPromptConfigType';
      jsonMode: boolean | null;
      frequencyPenalty: number | null;
      presencePenalty: number | null;
      temperature: number | null;
      topP: number | null;
    } | null;
    messages: Array<{
      __typename?: 'CopilotPromptMessageType';
      role: CopilotPromptMessageRole;
      content: string;
      params: Record<string, string> | null;
    }>;
  }>;
};

export type GetServerRuntimeConfigQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetServerRuntimeConfigQuery = {
  __typename?: 'Query';
  serverRuntimeConfig: Array<{
    __typename?: 'ServerRuntimeConfigType';
    id: string;
    module: string;
    key: string;
    description: string;
    value: Record<string, string>;
    type: RuntimeConfigType;
    updatedAt: string;
  }>;
};

export type GetServerServiceConfigsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetServerServiceConfigsQuery = {
  __typename?: 'Query';
  serverServiceConfigs: Array<{
    __typename?: 'ServerServiceConfig';
    name: string;
    config: any;
  }>;
};

export type GetTaskByDocumentIdQueryVariables = Exact<{
  input: DocumentTaskQueryInput;
}>;

export type GetTaskByDocumentIdQuery = {
  __typename?: 'Query';
  getTaskByDocumentId: Array<{
    __typename?: 'DocumentTaskResult';
    documentId: string;
    hasTask: boolean;
    message: string;
    totalCount: number;
    taskInfos: Array<{
      __typename?: 'DocumentTaskInfo';
      taskId: string;
      taskName: string;
      taskStatus: TaskStatus;
      parentTaskId: string | null;
      parentTaskName: string | null;
      parentTaskStatus: TaskStatus | null;
      isMainTask: boolean;
    }>;
  }>;
};

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type GetUserByEmailQuery = {
  __typename?: 'Query';
  userByEmail: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    features: Array<FeatureType>;
    hasPassword: boolean | null;
    emailVerified: boolean;
    avatarUrl: string | null;
    quota: {
      __typename?: 'UserQuota';
      humanReadable: {
        __typename?: 'UserQuotaHumanReadable';
        blobLimit: string;
        historyPeriod: string;
        memberLimit: string;
        name: string;
        storageQuota: string;
      };
    } | null;
  } | null;
};

export type GetUserFeaturesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserFeaturesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    features: Array<FeatureType>;
  } | null;
};

export type GetUserQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user:
    | {
        __typename: 'LimitedUserType';
        email: string;
        hasPassword: boolean | null;
      }
    | {
        __typename: 'UserType';
        id: string;
        name: string;
        avatarUrl: string | null;
        email: string;
        hasPassword: boolean | null;
      }
    | null;
};

export type GetUsersCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersCountQuery = { __typename?: 'Query'; usersCount: number };

export type GetWorkspaceFeaturesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceFeaturesQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; features: Array<FeatureType> };
};

export type GetWorkspaceInfoQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceInfoQuery = {
  __typename?: 'Query';
  isAdmin: boolean;
  isOwner: boolean;
  workspace: { __typename?: 'WorkspaceType'; team: boolean };
};

export type GetWorkspacePageMetaByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;

export type GetWorkspacePageMetaByIdQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    pageMeta: {
      __typename?: 'WorkspacePageMeta';
      createdAt: string;
      updatedAt: string;
      createdBy: {
        __typename?: 'EditorType';
        name: string;
        avatarUrl: string | null;
      } | null;
      updatedBy: {
        __typename?: 'EditorType';
        name: string;
        avatarUrl: string | null;
      } | null;
    };
  };
};

export type GetWorkspacePublicByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspacePublicByIdQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; public: boolean };
};

export type GetWorkspacePublicPageByIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;

export type GetWorkspacePublicPageByIdQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    publicPage: {
      __typename?: 'WorkspacePage';
      id: string;
      mode: PublicPageMode;
    } | null;
  };
};

export type GetWorkspacePublicPagesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspacePublicPagesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    publicPages: Array<{
      __typename?: 'WorkspacePage';
      id: string;
      mode: PublicPageMode;
    }>;
  };
};

export type GetWorkspaceSubscriptionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceSubscriptionQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    subscription: {
      __typename?: 'SubscriptionType';
      id: string | null;
      status: SubscriptionStatus;
      plan: SubscriptionPlan;
      recurring: SubscriptionRecurring;
      start: string;
      end: string | null;
      nextBillAt: string | null;
      canceledAt: string | null;
      variant: SubscriptionVariant | null;
    } | null;
  };
};

export type GetWorkspaceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspaceQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; id: string };
};

export type GetWorkspacesQueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkspacesQuery = {
  __typename?: 'Query';
  workspaces: Array<{
    __typename?: 'WorkspaceType';
    id: string;
    initialized: boolean;
    team: boolean;
    owner: { __typename?: 'UserType'; id: string };
  }>;
};

export type ListHistoryQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageDocId: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type ListHistoryQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    histories: Array<{
      __typename?: 'DocHistoryType';
      id: string;
      timestamp: string;
      editor: {
        __typename?: 'EditorType';
        name: string;
        avatarUrl: string | null;
      } | null;
    }>;
  };
};

export type InviteToDiscussionGroupMutationVariables = Exact<{
  input: InviteToDiscussionGroupInput;
}>;

export type InviteToDiscussionGroupMutation = {
  __typename?: 'Mutation';
  inviteToDiscussionGroup: string;
};

export type GetInvoicesCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetInvoicesCountQuery = {
  __typename?: 'Query';
  currentUser: { __typename?: 'UserType'; invoiceCount: number } | null;
};

export type InvoicesQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;

export type InvoicesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    invoiceCount: number;
    invoices: Array<{
      __typename?: 'InvoiceType';
      id: string | null;
      status: InvoiceStatus;
      currency: string;
      amount: number;
      reason: string;
      lastPaymentError: string | null;
      link: string | null;
      createdAt: string;
    }>;
  } | null;
};

export type LeaveWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sendLeaveMail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LeaveWorkspaceMutation = {
  __typename?: 'Mutation';
  leaveWorkspace: boolean;
};

export type ListUsersQueryVariables = Exact<{
  filter: ListUserInput;
}>;

export type ListUsersQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    features: Array<FeatureType>;
    hasPassword: boolean | null;
    emailVerified: boolean;
    avatarUrl: string | null;
    introduction: string | null;
    pointLevel: number | null;
    securityLevel: string | null;
    userTaskPermission: string | null;
    professionalFields: Array<string> | null;
  }>;
};

export type PricesQueryVariables = Exact<{ [key: string]: never }>;

export type PricesQuery = {
  __typename?: 'Query';
  prices: Array<{
    __typename?: 'SubscriptionPrice';
    type: string;
    plan: SubscriptionPlan;
    currency: string;
    amount: number | null;
    yearlyAmount: number | null;
    lifetimeAmount: number | null;
  }>;
};

export type PublishPageMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  mode?: InputMaybe<PublicPageMode>;
}>;

export type PublishPageMutation = {
  __typename?: 'Mutation';
  publishPage: {
    __typename?: 'WorkspacePage';
    id: string;
    mode: PublicPageMode;
  };
};

export type QuotaQueryVariables = Exact<{ [key: string]: never }>;

export type QuotaQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    quota: {
      __typename?: 'UserQuota';
      name: string;
      blobLimit: number;
      storageQuota: number;
      historyPeriod: number;
      memberLimit: number;
      humanReadable: {
        __typename?: 'UserQuotaHumanReadable';
        name: string;
        blobLimit: string;
        storageQuota: string;
        historyPeriod: string;
        memberLimit: string;
      };
    } | null;
    quotaUsage: { __typename?: 'UserQuotaUsage'; storageQuota: number };
  } | null;
};

export type RecoverDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
}>;

export type RecoverDocMutation = {
  __typename?: 'Mutation';
  recoverDoc: string;
};

export type RejectSubmittedTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
}>;

export type RejectSubmittedTaskMutation = {
  __typename?: 'Mutation';
  rejectSubmittedTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    status: TaskStatus;
    rejectionReason: string | null;
    completionNote: string | null;
    updatedAt: string;
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
  };
};

export type RejectTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  rejectionNote?: InputMaybe<Scalars['String']['input']>;
}>;

export type RejectTaskMutation = {
  __typename?: 'Mutation';
  rejectTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    status: TaskStatus;
    completionNote: string | null;
    ownerId: string | null;
    creatorId: string;
    createdAt: string;
    updatedAt: string;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
    parent: {
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
    } | null;
  };
};

export type RemoveAvatarMutationVariables = Exact<{ [key: string]: never }>;

export type RemoveAvatarMutation = {
  __typename?: 'Mutation';
  removeAvatar: { __typename?: 'RemoveAvatar'; success: boolean };
};

export type RemoveMemberFromDiscussionGroupMutationVariables = Exact<{
  input: RemoveMemberFromDiscussionGroupInput;
}>;

export type RemoveMemberFromDiscussionGroupMutation = {
  __typename?: 'Mutation';
  removeMemberFromDiscussionGroup: string;
};

export type ResumeSubscriptionMutationVariables = Exact<{
  plan?: InputMaybe<SubscriptionPlan>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ResumeSubscriptionMutation = {
  __typename?: 'Mutation';
  resumeSubscription: {
    __typename?: 'SubscriptionType';
    id: string | null;
    status: SubscriptionStatus;
    nextBillAt: string | null;
    start: string;
    end: string | null;
  };
};

export type RevokeMemberPermissionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type RevokeMemberPermissionMutation = {
  __typename?: 'Mutation';
  revoke: boolean;
};

export type RevokePublicPageMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;

export type RevokePublicPageMutation = {
  __typename?: 'Mutation';
  revokePublicPage: {
    __typename?: 'WorkspacePage';
    id: string;
    mode: PublicPageMode;
    public: boolean;
  };
};

export type SearchUsersByDomainQueryVariables = Exact<{
  input: SearchUserInput;
}>;

export type SearchUsersByDomainQuery = {
  __typename?: 'Query';
  searchUsers: Array<{
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    avatarUrl: string | null;
    emailVerified: boolean;
    hasPassword: boolean | null;
  }>;
};

export type SendChangeEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendChangeEmailMutation = {
  __typename?: 'Mutation';
  sendChangeEmail: boolean;
};

export type SendChangePasswordEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendChangePasswordEmailMutation = {
  __typename?: 'Mutation';
  sendChangePasswordEmail: boolean;
};

export type SendDiscussionMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;

export type SendDiscussionMessageMutation = {
  __typename?: 'Mutation';
  sendDiscussionMessage: string;
};

export type SendSetPasswordEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendSetPasswordEmailMutation = {
  __typename?: 'Mutation';
  sendSetPasswordEmail: boolean;
};

export type SendVerifyChangeEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  callbackUrl: Scalars['String']['input'];
}>;

export type SendVerifyChangeEmailMutation = {
  __typename?: 'Mutation';
  sendVerifyChangeEmail: boolean;
};

export type SendVerifyEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendVerifyEmailMutation = {
  __typename?: 'Mutation';
  sendVerifyEmail: boolean;
};

export type ServerConfigQueryVariables = Exact<{ [key: string]: never }>;

export type ServerConfigQuery = {
  __typename?: 'Query';
  serverConfig: {
    __typename?: 'ServerConfigType';
    version: string;
    baseUrl: string;
    name: string;
    features: Array<ServerFeature>;
    type: ServerDeploymentType;
    initialized: boolean;
    credentialsRequirement: {
      __typename?: 'CredentialsRequirementType';
      password: {
        __typename?: 'PasswordLimitsType';
        minLength: number;
        maxLength: number;
      };
    };
  };
};

export type SetWorkspacePublicByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  public: Scalars['Boolean']['input'];
}>;

export type SetWorkspacePublicByIdMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type SubmitTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  submissionNote?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
}>;

export type SubmitTaskMutation = {
  __typename?: 'Mutation';
  submitTask: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    status: TaskStatus;
    completionNote: string | null;
    documentId: string | null;
    documentUrl: string | null;
    ownerId: string | null;
    creatorId: string;
    createdAt: string;
    updatedAt: string;
    points: number;
    priority: TaskPriority;
    deadline: string | null;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
    parent: {
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
    } | null;
  };
};

export type SubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type SubscriptionQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    subscriptions: Array<{
      __typename?: 'SubscriptionType';
      id: string | null;
      status: SubscriptionStatus;
      plan: SubscriptionPlan;
      recurring: SubscriptionRecurring;
      start: string;
      end: string | null;
      nextBillAt: string | null;
      canceledAt: string | null;
      variant: SubscriptionVariant | null;
    }>;
  } | null;
};

export type SummarizeArticleMutationVariables = Exact<{
  input: ArticleSummaryInput;
}>;

export type SummarizeArticleMutation = {
  __typename?: 'Mutation';
  summarizeArticle: {
    __typename?: 'ArticleSummaryResult';
    success: boolean;
    message: string;
    summary: string;
    originalTitle: string;
  };
};

export type GetTaskWithMyAssignmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskWithMyAssignmentQuery = {
  __typename?: 'Query';
  task: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    description: string | null;
    status: TaskStatus;
    priority: TaskPriority;
    points: number;
    createdAt: string;
    updatedAt: string;
    completedAt: string | null;
    deadline: string | null;
    completionNote: string | null;
    workspaceId: string;
    parentId: string | null;
    creatorId: string;
    ownerIds: Array<string>;
    groupIds: Array<string>;
    documentId: string | null;
    documentUrl: string | null;
    rejectionReason: string | null;
    taskType: number;
    assignmentRecords: Array<{
      __typename?: 'TaskAssignmentRecordType';
      id: string;
      userId: string;
      taskId: string;
      userType: string;
      assignedBy: string;
      assignedAt: string;
      assignmentType: string;
      status: TaskStatus;
      documentId: string | null;
      documentUrl: string | null;
      completionNote: string | null;
      submittedAt: string | null;
      completedAt: string | null;
      rejectionReason: string | null;
      points: number;
      assignedByUser: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
      reviewer: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      userInfo: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
    }>;
    myAssignmentRecord: {
      __typename?: 'TaskAssignmentRecordType';
      id: string;
      userId: string;
      taskId: string;
      userType: string;
      assignedBy: string;
      assignedAt: string;
      assignmentType: string;
      status: TaskStatus;
      documentId: string | null;
      documentUrl: string | null;
      completionNote: string | null;
      submittedAt: string | null;
      completedAt: string | null;
      rejectionReason: string | null;
      points: number;
      assignedByUser: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
      reviewer: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      userInfo: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
    } | null;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
    parent: {
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
    } | null;
    subtasks: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      description: string | null;
      status: TaskStatus;
      priority: TaskPriority;
      points: number;
      createdAt: string;
      deadline: string | null;
      ownerIds: Array<string>;
      groupIds: Array<string>;
      documentId: string | null;
      documentUrl: string | null;
      rejectionReason: string | null;
      isPublic: boolean;
      taskType: number;
      assignmentRecords: Array<{
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        taskId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        rejectionReason: string | null;
        points: number;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      }>;
      myAssignmentRecord: {
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        rejectionReason: string | null;
        points: number;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      } | null;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
      owner: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
    }>;
  };
};

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskQuery = {
  __typename?: 'Query';
  task: {
    __typename?: 'TaskType';
    id: string;
    name: string;
    description: string | null;
    status: TaskStatus;
    priority: TaskPriority;
    points: number;
    createdAt: string;
    updatedAt: string;
    completedAt: string | null;
    deadline: string | null;
    completionNote: string | null;
    workspaceId: string;
    parentId: string | null;
    creatorId: string;
    ownerIds: Array<string>;
    groupIds: Array<string>;
    documentId: string | null;
    documentUrl: string | null;
    rejectionReason: string | null;
    taskType: number;
    assignmentRecords: Array<{
      __typename?: 'TaskAssignmentRecordType';
      id: string;
      userId: string;
      taskId: string;
      userType: string;
      assignedBy: string;
      assignedAt: string;
      assignmentType: string;
      status: TaskStatus;
      documentId: string | null;
      documentUrl: string | null;
      completionNote: string | null;
      submittedAt: string | null;
      completedAt: string | null;
      reviewedAt: string | null;
      rejectionReason: string | null;
      points: number;
      assignedByUser: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
      reviewer: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      userInfo: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
    }>;
    creator: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    };
    owner: {
      __typename?: 'UserType';
      id: string;
      name: string;
      email: string;
    } | null;
    parent: {
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
    } | null;
    subtasks: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      description: string | null;
      status: TaskStatus;
      priority: TaskPriority;
      points: number;
      createdAt: string;
      deadline: string | null;
      ownerIds: Array<string>;
      groupIds: Array<string>;
      documentId: string | null;
      documentUrl: string | null;
      rejectionReason: string | null;
      isPublic: boolean;
      taskType: number;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
      owner: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      assignmentRecords: Array<{
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        taskId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        reviewedAt: string | null;
        rejectionReason: string | null;
        points: number;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      }>;
    }>;
  };
};

export type GetMyAssignedTasksQueryVariables = Exact<{
  input: TaskListInput;
}>;

export type GetMyAssignedTasksQuery = {
  __typename?: 'Query';
  tasks: {
    __typename?: 'TaskListResult';
    total: number;
    list: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
      priority: TaskPriority;
      points: number;
      deadline: string | null;
      description: string | null;
      creatorId: string;
      ownerId: string | null;
      taskType: number;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        avatarUrl: string | null;
        email: string;
      };
      owner: { __typename?: 'UserType'; id: string; name: string } | null;
      parent: {
        __typename?: 'TaskType';
        id: string;
        name: string;
        description: string | null;
        creator: {
          __typename?: 'UserType';
          id: string;
          name: string;
          avatarUrl: string | null;
          email: string;
        };
      } | null;
      assignmentRecords: Array<{
        __typename?: 'TaskAssignmentRecordType';
        id: string;
        userId: string;
        taskId: string;
        userType: string;
        assignedBy: string;
        assignedAt: string;
        assignmentType: string;
        status: TaskStatus;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        submittedAt: string | null;
        completedAt: string | null;
        reviewerId: string | null;
        reviewedAt: string | null;
        rejectionReason: string | null;
        points: number;
        pointsPaid: boolean;
        pointsPaidAt: string | null;
        createdAt: string;
        updatedAt: string;
        assignedByUser: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        };
        reviewer: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
        userInfo: {
          __typename?: 'UserType';
          id: string;
          name: string;
          email: string;
        } | null;
      }>;
      subtasks: Array<{
        __typename?: 'TaskType';
        id: string;
        name: string;
        status: TaskStatus;
        taskType: number;
        assignmentRecords: Array<{
          __typename?: 'TaskAssignmentRecordType';
          id: string;
          userId: string;
          taskId: string;
          userType: string;
          assignedBy: string;
          assignedAt: string;
          assignmentType: string;
          status: TaskStatus;
          documentId: string | null;
          documentUrl: string | null;
          completionNote: string | null;
          submittedAt: string | null;
          completedAt: string | null;
          reviewerId: string | null;
          reviewedAt: string | null;
          rejectionReason: string | null;
          points: number;
          pointsPaid: boolean;
          pointsPaidAt: string | null;
          createdAt: string;
          updatedAt: string;
          assignedByUser: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          };
          reviewer: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          } | null;
          userInfo: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          } | null;
        }>;
      }>;
    }>;
  };
};

export type GetMyCreatedTasksQueryVariables = Exact<{
  input: TaskListInput;
}>;

export type GetMyCreatedTasksQuery = {
  __typename?: 'Query';
  tasks: {
    __typename?: 'TaskListResult';
    total: number;
    list: Array<{
      __typename?: 'TaskType';
      id: string;
      name: string;
      status: TaskStatus;
      priority: TaskPriority;
      points: number;
      createdAt: string;
      deadline: string | null;
      description: string | null;
      creatorId: string;
      ownerId: string | null;
      documentId: string | null;
      documentUrl: string | null;
      completionNote: string | null;
      rejectionReason: string | null;
      taskType: number;
      creator: {
        __typename?: 'UserType';
        avatarUrl: string | null;
        id: string;
        name: string;
        email: string;
      };
      owner: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      } | null;
      subtasks: Array<{
        __typename?: 'TaskType';
        id: string;
        name: string;
        status: TaskStatus;
        points: number;
        ownerId: string | null;
        documentId: string | null;
        documentUrl: string | null;
        completionNote: string | null;
        description: string | null;
        isPublic: boolean;
        deadline: string | null;
        rejectionReason: string | null;
        taskType: number;
        parent: { __typename?: 'TaskType'; id: string; name: string } | null;
        owner: { __typename?: 'UserType'; id: string; name: string } | null;
        assignmentRecords: Array<{
          __typename?: 'TaskAssignmentRecordType';
          id: string;
          userId: string;
          taskId: string;
          userType: string;
          assignedBy: string;
          assignedAt: string;
          assignmentType: string;
          status: TaskStatus;
          documentId: string | null;
          documentUrl: string | null;
          completionNote: string | null;
          submittedAt: string | null;
          completedAt: string | null;
          reviewerId: string | null;
          reviewedAt: string | null;
          rejectionReason: string | null;
          points: number;
          pointsPaid: boolean;
          pointsPaidAt: string | null;
          createdAt: string;
          updatedAt: string;
          assignedByUser: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          };
          reviewer: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
          } | null;
          userInfo: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
            avatarUrl: string | null;
          } | null;
        }>;
      }>;
    }>;
  };
};

export type UpdateAccountFeaturesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  features: Array<FeatureType> | FeatureType;
}>;

export type UpdateAccountFeaturesMutation = {
  __typename?: 'Mutation';
  updateUserFeatures: Array<FeatureType>;
};

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ManageUserInput;
}>;

export type UpdateAccountMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
  };
};

export type UpdateDocumentTemplateMutationVariables = Exact<{
  input: UpdateDocumentTemplateInput;
}>;

export type UpdateDocumentTemplateMutation = {
  __typename?: 'Mutation';
  updateDocumentTemplate: {
    __typename?: 'DocumentTemplateResult';
    message: string;
    template: {
      __typename?: 'DocumentTemplateType';
      id: string;
      name: string;
      documentId: string;
      workspaceId: string | null;
      createdBy: string;
      createdAt: string;
      updatedAt: string;
      creator: {
        __typename?: 'UserType';
        id: string;
        name: string;
        email: string;
      };
    };
  };
};

export type UpdatePromptMutationVariables = Exact<{
  name: Scalars['String']['input'];
  messages: Array<CopilotPromptMessageInput> | CopilotPromptMessageInput;
}>;

export type UpdatePromptMutation = {
  __typename?: 'Mutation';
  updateCopilotPrompt: {
    __typename?: 'CopilotPromptType';
    name: string;
    model: string;
    action: string | null;
    config: {
      __typename?: 'CopilotPromptConfigType';
      jsonMode: boolean | null;
      frequencyPenalty: number | null;
      presencePenalty: number | null;
      temperature: number | null;
      topP: number | null;
    } | null;
    messages: Array<{
      __typename?: 'CopilotPromptMessageType';
      role: CopilotPromptMessageRole;
      content: string;
      params: Record<string, string> | null;
    }>;
  };
};

export type UpdateServerRuntimeConfigsMutationVariables = Exact<{
  updates: Scalars['JSONObject']['input'];
}>;

export type UpdateServerRuntimeConfigsMutation = {
  __typename?: 'Mutation';
  updateRuntimeConfigs: Array<{
    __typename?: 'ServerRuntimeConfigType';
    key: string;
    value: Record<string, string>;
  }>;
};

export type UpdateSubscriptionMutationVariables = Exact<{
  plan?: InputMaybe<SubscriptionPlan>;
  recurring: SubscriptionRecurring;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation';
  updateSubscriptionRecurring: {
    __typename?: 'SubscriptionType';
    id: string | null;
    plan: SubscriptionPlan;
    recurring: SubscriptionRecurring;
    nextBillAt: string | null;
  };
};

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserProfileMutation = {
  __typename?: 'Mutation';
  updateProfile: { __typename?: 'UserType'; id: string; name: string };
};

export type UploadAvatarMutationVariables = Exact<{
  avatar: Scalars['Upload']['input'];
}>;

export type UploadAvatarMutation = {
  __typename?: 'Mutation';
  uploadAvatar: {
    __typename?: 'UserType';
    id: string;
    name: string;
    avatarUrl: string | null;
    email: string;
  };
};

export type GetUserTaskSummaryQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUserTaskSummaryQuery = {
  __typename?: 'Query';
  userTaskSummary: {
    __typename?: 'UserTaskSummary';
    createdTasksCount: number;
    myTasksCount: number;
    pointsBalance: number;
  };
};

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type VerifyEmailMutation = {
  __typename?: 'Mutation';
  verifyEmail: boolean;
};

export type GetWorkspaceConfigQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspaceConfigQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    enableAi: boolean;
    enableUrlPreview: boolean;
    inviteLink: {
      __typename?: 'InviteLink';
      link: string;
      expireTime: string;
    } | null;
  };
};

export type SetEnableAiMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enableAi: Scalars['Boolean']['input'];
}>;

export type SetEnableAiMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type SetEnableUrlPreviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enableUrlPreview: Scalars['Boolean']['input'];
}>;

export type SetEnableUrlPreviewMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type EnabledFeaturesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type EnabledFeaturesQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; features: Array<FeatureType> };
};

export type AvailableFeaturesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AvailableFeaturesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    availableFeatures: Array<FeatureType>;
  };
};

export type SetWorkspaceExperimentalFeatureMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  feature: FeatureType;
  enable: Scalars['Boolean']['input'];
}>;

export type SetWorkspaceExperimentalFeatureMutation = {
  __typename?: 'Mutation';
  setWorkspaceExperimentalFeature: boolean;
};

export type AddWorkspaceFeatureMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  feature: FeatureType;
}>;

export type AddWorkspaceFeatureMutation = {
  __typename?: 'Mutation';
  addWorkspaceFeature: number;
};

export type ListWorkspaceFeaturesQueryVariables = Exact<{
  feature: FeatureType;
}>;

export type ListWorkspaceFeaturesQuery = {
  __typename?: 'Query';
  listWorkspaceFeatures: Array<{
    __typename?: 'WorkspaceType';
    id: string;
    public: boolean;
    createdAt: string;
    memberCount: number;
    features: Array<FeatureType>;
    owner: { __typename?: 'UserType'; id: string };
  }>;
};

export type RemoveWorkspaceFeatureMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  feature: FeatureType;
}>;

export type RemoveWorkspaceFeatureMutation = {
  __typename?: 'Mutation';
  removeWorkspaceFeature: number;
};

export type InviteByEmailMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  permission: Permission;
  sendInviteMail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type InviteByEmailMutation = { __typename?: 'Mutation'; invite: string };

export type InviteByEmailsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  sendInviteMail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type InviteByEmailsMutation = {
  __typename?: 'Mutation';
  inviteBatch: Array<{
    __typename?: 'InviteResult';
    email: string;
    inviteId: string | null;
    sentSuccess: boolean;
  }>;
};

export type AcceptInviteByInviteIdMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
  sendAcceptMail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AcceptInviteByInviteIdMutation = {
  __typename?: 'Mutation';
  acceptInviteById: boolean;
};

export type InviteBatchMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  sendInviteMail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type InviteBatchMutation = {
  __typename?: 'Mutation';
  inviteBatch: Array<{
    __typename?: 'InviteResult';
    email: string;
    inviteId: string | null;
    sentSuccess: boolean;
  }>;
};

export type CreateInviteLinkMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  expireTime: WorkspaceInviteLinkExpireTime;
}>;

export type CreateInviteLinkMutation = {
  __typename?: 'Mutation';
  createInviteLink: {
    __typename?: 'InviteLink';
    link: string;
    expireTime: string;
  };
};

export type RevokeInviteLinkMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RevokeInviteLinkMutation = {
  __typename?: 'Mutation';
  revokeInviteLink: boolean;
};

export type WorkspaceInvoicesQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceInvoicesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    invoiceCount: number;
    invoices: Array<{
      __typename?: 'InvoiceType';
      id: string | null;
      status: InvoiceStatus;
      currency: string;
      amount: number;
      reason: string;
      lastPaymentError: string | null;
      link: string | null;
      createdAt: string;
    }>;
  };
};

export type WorkspaceQuotaQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type WorkspaceQuotaQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    quota: {
      __typename?: 'QuotaQueryType';
      name: string;
      blobLimit: number;
      storageQuota: number;
      historyPeriod: number;
      memberLimit: number;
      memberCount: number;
      usedSize: number;
      humanReadable: {
        __typename?: 'HumanReadableQuotaType';
        name: string;
        blobLimit: string;
        storageQuota: string;
        historyPeriod: string;
        memberLimit: string;
      };
    };
  };
};

export type ApproveWorkspaceTeamMemberMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type ApproveWorkspaceTeamMemberMutation = {
  __typename?: 'Mutation';
  approveMember: string;
};

export type GrantWorkspaceTeamMemberMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  permission: Permission;
}>;

export type GrantWorkspaceTeamMemberMutation = {
  __typename?: 'Mutation';
  grantMember: string;
};

export type Queries =
  | {
      name: 'adminServerConfigQuery';
      variables: AdminServerConfigQueryVariables;
      response: AdminServerConfigQuery;
    }
  | {
      name: 'getAllPublicTasksQuery';
      variables: GetAllPublicTasksQueryVariables;
      response: GetAllPublicTasksQuery;
    }
  | {
      name: 'listBlobsQuery';
      variables: ListBlobsQueryVariables;
      response: ListBlobsQuery;
    }
  | {
      name: 'copilotQuotaQuery';
      variables: CopilotQuotaQueryVariables;
      response: CopilotQuotaQuery;
    }
  | {
      name: 'getDiscussionGroupsQuery';
      variables: GetDiscussionGroupsQueryVariables;
      response: GetDiscussionGroupsQuery;
    }
  | {
      name: 'getDiscussionMessagesQuery';
      variables: GetDiscussionMessagesQueryVariables;
      response: GetDiscussionMessagesQuery;
    }
  | {
      name: 'documentTemplateDetailQuery';
      variables: DocumentTemplateDetailQueryVariables;
      response: DocumentTemplateDetailQuery;
    }
  | {
      name: 'documentTemplateInfoByDocumentIdQuery';
      variables: DocumentTemplateInfoByDocumentIdQueryVariables;
      response: DocumentTemplateInfoByDocumentIdQuery;
    }
  | {
      name: 'documentTemplatesListQuery';
      variables: DocumentTemplatesListQueryVariables;
      response: DocumentTemplatesListQuery;
    }
  | {
      name: 'getCopilotHistoriesQuery';
      variables: GetCopilotHistoriesQueryVariables;
      response: GetCopilotHistoriesQuery;
    }
  | {
      name: 'getCopilotHistoryIdsQuery';
      variables: GetCopilotHistoryIdsQueryVariables;
      response: GetCopilotHistoryIdsQuery;
    }
  | {
      name: 'getCopilotSessionsQuery';
      variables: GetCopilotSessionsQueryVariables;
      response: GetCopilotSessionsQuery;
    }
  | {
      name: 'getCurrentUserFeaturesQuery';
      variables: GetCurrentUserFeaturesQueryVariables;
      response: GetCurrentUserFeaturesQuery;
    }
  | {
      name: 'getCurrentUserQuery';
      variables: GetCurrentUserQueryVariables;
      response: GetCurrentUserQuery;
    }
  | {
      name: 'getDocumentTemplateQuery';
      variables: GetDocumentTemplateQueryVariables;
      response: GetDocumentTemplateQuery;
    }
  | {
      name: 'getInviteInfoQuery';
      variables: GetInviteInfoQueryVariables;
      response: GetInviteInfoQuery;
    }
  | {
      name: 'getIsAdminQuery';
      variables: GetIsAdminQueryVariables;
      response: GetIsAdminQuery;
    }
  | {
      name: 'getIsOwnerQuery';
      variables: GetIsOwnerQueryVariables;
      response: GetIsOwnerQuery;
    }
  | {
      name: 'getMemberCountByWorkspaceIdQuery';
      variables: GetMemberCountByWorkspaceIdQueryVariables;
      response: GetMemberCountByWorkspaceIdQuery;
    }
  | {
      name: 'getMembersByWorkspaceIdQuery';
      variables: GetMembersByWorkspaceIdQueryVariables;
      response: GetMembersByWorkspaceIdQuery;
    }
  | {
      name: 'oauthProvidersQuery';
      variables: OauthProvidersQueryVariables;
      response: OauthProvidersQuery;
    }
  | {
      name: 'getPromptsQuery';
      variables: GetPromptsQueryVariables;
      response: GetPromptsQuery;
    }
  | {
      name: 'getServerRuntimeConfigQuery';
      variables: GetServerRuntimeConfigQueryVariables;
      response: GetServerRuntimeConfigQuery;
    }
  | {
      name: 'getServerServiceConfigsQuery';
      variables: GetServerServiceConfigsQueryVariables;
      response: GetServerServiceConfigsQuery;
    }
  | {
      name: 'getTaskByDocumentIdQuery';
      variables: GetTaskByDocumentIdQueryVariables;
      response: GetTaskByDocumentIdQuery;
    }
  | {
      name: 'getUserByEmailQuery';
      variables: GetUserByEmailQueryVariables;
      response: GetUserByEmailQuery;
    }
  | {
      name: 'getUserFeaturesQuery';
      variables: GetUserFeaturesQueryVariables;
      response: GetUserFeaturesQuery;
    }
  | {
      name: 'getUserQuery';
      variables: GetUserQueryVariables;
      response: GetUserQuery;
    }
  | {
      name: 'getUsersCountQuery';
      variables: GetUsersCountQueryVariables;
      response: GetUsersCountQuery;
    }
  | {
      name: 'getWorkspaceFeaturesQuery';
      variables: GetWorkspaceFeaturesQueryVariables;
      response: GetWorkspaceFeaturesQuery;
    }
  | {
      name: 'getWorkspaceInfoQuery';
      variables: GetWorkspaceInfoQueryVariables;
      response: GetWorkspaceInfoQuery;
    }
  | {
      name: 'getWorkspacePageMetaByIdQuery';
      variables: GetWorkspacePageMetaByIdQueryVariables;
      response: GetWorkspacePageMetaByIdQuery;
    }
  | {
      name: 'getWorkspacePublicByIdQuery';
      variables: GetWorkspacePublicByIdQueryVariables;
      response: GetWorkspacePublicByIdQuery;
    }
  | {
      name: 'getWorkspacePublicPageByIdQuery';
      variables: GetWorkspacePublicPageByIdQueryVariables;
      response: GetWorkspacePublicPageByIdQuery;
    }
  | {
      name: 'getWorkspacePublicPagesQuery';
      variables: GetWorkspacePublicPagesQueryVariables;
      response: GetWorkspacePublicPagesQuery;
    }
  | {
      name: 'getWorkspaceSubscriptionQuery';
      variables: GetWorkspaceSubscriptionQueryVariables;
      response: GetWorkspaceSubscriptionQuery;
    }
  | {
      name: 'getWorkspaceQuery';
      variables: GetWorkspaceQueryVariables;
      response: GetWorkspaceQuery;
    }
  | {
      name: 'getWorkspacesQuery';
      variables: GetWorkspacesQueryVariables;
      response: GetWorkspacesQuery;
    }
  | {
      name: 'listHistoryQuery';
      variables: ListHistoryQueryVariables;
      response: ListHistoryQuery;
    }
  | {
      name: 'getInvoicesCountQuery';
      variables: GetInvoicesCountQueryVariables;
      response: GetInvoicesCountQuery;
    }
  | {
      name: 'invoicesQuery';
      variables: InvoicesQueryVariables;
      response: InvoicesQuery;
    }
  | {
      name: 'listUsersQuery';
      variables: ListUsersQueryVariables;
      response: ListUsersQuery;
    }
  | {
      name: 'pricesQuery';
      variables: PricesQueryVariables;
      response: PricesQuery;
    }
  | {
      name: 'quotaQuery';
      variables: QuotaQueryVariables;
      response: QuotaQuery;
    }
  | {
      name: 'searchUsersByDomainQuery';
      variables: SearchUsersByDomainQueryVariables;
      response: SearchUsersByDomainQuery;
    }
  | {
      name: 'serverConfigQuery';
      variables: ServerConfigQueryVariables;
      response: ServerConfigQuery;
    }
  | {
      name: 'subscriptionQuery';
      variables: SubscriptionQueryVariables;
      response: SubscriptionQuery;
    }
  | {
      name: 'getTaskWithMyAssignmentQuery';
      variables: GetTaskWithMyAssignmentQueryVariables;
      response: GetTaskWithMyAssignmentQuery;
    }
  | {
      name: 'getTaskQuery';
      variables: GetTaskQueryVariables;
      response: GetTaskQuery;
    }
  | {
      name: 'getMyAssignedTasksQuery';
      variables: GetMyAssignedTasksQueryVariables;
      response: GetMyAssignedTasksQuery;
    }
  | {
      name: 'getMyCreatedTasksQuery';
      variables: GetMyCreatedTasksQueryVariables;
      response: GetMyCreatedTasksQuery;
    }
  | {
      name: 'getUserTaskSummaryQuery';
      variables: GetUserTaskSummaryQueryVariables;
      response: GetUserTaskSummaryQuery;
    }
  | {
      name: 'getWorkspaceConfigQuery';
      variables: GetWorkspaceConfigQueryVariables;
      response: GetWorkspaceConfigQuery;
    }
  | {
      name: 'enabledFeaturesQuery';
      variables: EnabledFeaturesQueryVariables;
      response: EnabledFeaturesQuery;
    }
  | {
      name: 'availableFeaturesQuery';
      variables: AvailableFeaturesQueryVariables;
      response: AvailableFeaturesQuery;
    }
  | {
      name: 'listWorkspaceFeaturesQuery';
      variables: ListWorkspaceFeaturesQueryVariables;
      response: ListWorkspaceFeaturesQuery;
    }
  | {
      name: 'workspaceInvoicesQuery';
      variables: WorkspaceInvoicesQueryVariables;
      response: WorkspaceInvoicesQuery;
    }
  | {
      name: 'workspaceQuotaQuery';
      variables: WorkspaceQuotaQueryVariables;
      response: WorkspaceQuotaQuery;
    };

export type Mutations =
  | {
      name: 'acceptSubmittedTaskMutation';
      variables: AcceptSubmittedTaskMutationVariables;
      response: AcceptSubmittedTaskMutation;
    }
  | {
      name: 'acceptSubtaskMutation';
      variables: AcceptSubtaskMutationVariables;
      response: AcceptSubtaskMutation;
    }
  | {
      name: 'createMainTaskWithSubtasksMutation';
      variables: CreateMainTaskWithSubtasksMutationVariables;
      response: CreateMainTaskWithSubtasksMutation;
    }
  | {
      name: 'deleteBlobMutation';
      variables: DeleteBlobMutationVariables;
      response: DeleteBlobMutation;
    }
  | {
      name: 'releaseDeletedBlobsMutation';
      variables: ReleaseDeletedBlobsMutationVariables;
      response: ReleaseDeletedBlobsMutation;
    }
  | {
      name: 'setBlobMutation';
      variables: SetBlobMutationVariables;
      response: SetBlobMutation;
    }
  | {
      name: 'cancelSingleSubtaskMutation';
      variables: CancelSingleSubtaskMutationVariables;
      response: CancelSingleSubtaskMutation;
    }
  | {
      name: 'cancelMainTaskMutation';
      variables: CancelMainTaskMutationVariables;
      response: CancelMainTaskMutation;
    }
  | {
      name: 'cancelSubscriptionMutation';
      variables: CancelSubscriptionMutationVariables;
      response: CancelSubscriptionMutation;
    }
  | {
      name: 'changeEmailMutation';
      variables: ChangeEmailMutationVariables;
      response: ChangeEmailMutation;
    }
  | {
      name: 'createChangePasswordUrlMutation';
      variables: CreateChangePasswordUrlMutationVariables;
      response: CreateChangePasswordUrlMutation;
    }
  | {
      name: 'changePasswordMutation';
      variables: ChangePasswordMutationVariables;
      response: ChangePasswordMutation;
    }
  | {
      name: 'completeTaskMutation';
      variables: CompleteTaskMutationVariables;
      response: CompleteTaskMutation;
    }
  | {
      name: 'compute_contributionsMutation';
      variables: Compute_contributionsMutationVariables;
      response: Compute_contributionsMutation;
    }
  | {
      name: 'updateSubtaskStatusMutation';
      variables: UpdateSubtaskStatusMutationVariables;
      response: UpdateSubtaskStatusMutation;
    }
  | {
      name: 'cleanupCopilotSessionMutation';
      variables: CleanupCopilotSessionMutationVariables;
      response: CleanupCopilotSessionMutation;
    }
  | {
      name: 'createCheckoutSessionMutation';
      variables: CreateCheckoutSessionMutationVariables;
      response: CreateCheckoutSessionMutation;
    }
  | {
      name: 'createCopilotMessageMutation';
      variables: CreateCopilotMessageMutationVariables;
      response: CreateCopilotMessageMutation;
    }
  | {
      name: 'createCopilotSessionMutation';
      variables: CreateCopilotSessionMutationVariables;
      response: CreateCopilotSessionMutation;
    }
  | {
      name: 'createCustomerPortalMutation';
      variables: CreateCustomerPortalMutationVariables;
      response: CreateCustomerPortalMutation;
    }
  | {
      name: 'createDiscussionGroupMutation';
      variables: CreateDiscussionGroupMutationVariables;
      response: CreateDiscussionGroupMutation;
    }
  | {
      name: 'createDocumentTemplateMutation';
      variables: CreateDocumentTemplateMutationVariables;
      response: CreateDocumentTemplateMutation;
    }
  | {
      name: 'createUserMutation';
      variables: CreateUserMutationVariables;
      response: CreateUserMutation;
    }
  | {
      name: 'createWorkspaceMutation';
      variables: CreateWorkspaceMutationVariables;
      response: CreateWorkspaceMutation;
    }
  | {
      name: 'deleteAccountMutation';
      variables: DeleteAccountMutationVariables;
      response: DeleteAccountMutation;
    }
  | {
      name: 'deleteDocumentTemplateMutation';
      variables: DeleteDocumentTemplateMutationVariables;
      response: DeleteDocumentTemplateMutation;
    }
  | {
      name: 'deleteUserMutation';
      variables: DeleteUserMutationVariables;
      response: DeleteUserMutation;
    }
  | {
      name: 'deleteWorkspaceMutation';
      variables: DeleteWorkspaceMutationVariables;
      response: DeleteWorkspaceMutation;
    }
  | {
      name: 'dissolveDiscussionGroupMutation';
      variables: DissolveDiscussionGroupMutationVariables;
      response: DissolveDiscussionGroupMutation;
    }
  | {
      name: 'mixedOperationsMutation';
      variables: MixedOperationsMutationVariables;
      response: MixedOperationsMutation;
    }
  | {
      name: 'forkCopilotSessionMutation';
      variables: ForkCopilotSessionMutationVariables;
      response: ForkCopilotSessionMutation;
    }
  | {
      name: 'genhistoryMutation';
      variables: GenhistoryMutationVariables;
      response: GenhistoryMutation;
    }
  | {
      name: 'inviteToDiscussionGroupMutation';
      variables: InviteToDiscussionGroupMutationVariables;
      response: InviteToDiscussionGroupMutation;
    }
  | {
      name: 'leaveWorkspaceMutation';
      variables: LeaveWorkspaceMutationVariables;
      response: LeaveWorkspaceMutation;
    }
  | {
      name: 'publishPageMutation';
      variables: PublishPageMutationVariables;
      response: PublishPageMutation;
    }
  | {
      name: 'recoverDocMutation';
      variables: RecoverDocMutationVariables;
      response: RecoverDocMutation;
    }
  | {
      name: 'rejectSubmittedTaskMutation';
      variables: RejectSubmittedTaskMutationVariables;
      response: RejectSubmittedTaskMutation;
    }
  | {
      name: 'rejectTaskMutation';
      variables: RejectTaskMutationVariables;
      response: RejectTaskMutation;
    }
  | {
      name: 'removeAvatarMutation';
      variables: RemoveAvatarMutationVariables;
      response: RemoveAvatarMutation;
    }
  | {
      name: 'removeMemberFromDiscussionGroupMutation';
      variables: RemoveMemberFromDiscussionGroupMutationVariables;
      response: RemoveMemberFromDiscussionGroupMutation;
    }
  | {
      name: 'resumeSubscriptionMutation';
      variables: ResumeSubscriptionMutationVariables;
      response: ResumeSubscriptionMutation;
    }
  | {
      name: 'revokeMemberPermissionMutation';
      variables: RevokeMemberPermissionMutationVariables;
      response: RevokeMemberPermissionMutation;
    }
  | {
      name: 'revokePublicPageMutation';
      variables: RevokePublicPageMutationVariables;
      response: RevokePublicPageMutation;
    }
  | {
      name: 'sendChangeEmailMutation';
      variables: SendChangeEmailMutationVariables;
      response: SendChangeEmailMutation;
    }
  | {
      name: 'sendChangePasswordEmailMutation';
      variables: SendChangePasswordEmailMutationVariables;
      response: SendChangePasswordEmailMutation;
    }
  | {
      name: 'sendDiscussionMessageMutation';
      variables: SendDiscussionMessageMutationVariables;
      response: SendDiscussionMessageMutation;
    }
  | {
      name: 'sendSetPasswordEmailMutation';
      variables: SendSetPasswordEmailMutationVariables;
      response: SendSetPasswordEmailMutation;
    }
  | {
      name: 'sendVerifyChangeEmailMutation';
      variables: SendVerifyChangeEmailMutationVariables;
      response: SendVerifyChangeEmailMutation;
    }
  | {
      name: 'sendVerifyEmailMutation';
      variables: SendVerifyEmailMutationVariables;
      response: SendVerifyEmailMutation;
    }
  | {
      name: 'setWorkspacePublicByIdMutation';
      variables: SetWorkspacePublicByIdMutationVariables;
      response: SetWorkspacePublicByIdMutation;
    }
  | {
      name: 'submitTaskMutation';
      variables: SubmitTaskMutationVariables;
      response: SubmitTaskMutation;
    }
  | {
      name: 'summarizeArticleMutation';
      variables: SummarizeArticleMutationVariables;
      response: SummarizeArticleMutation;
    }
  | {
      name: 'updateAccountFeaturesMutation';
      variables: UpdateAccountFeaturesMutationVariables;
      response: UpdateAccountFeaturesMutation;
    }
  | {
      name: 'updateAccountMutation';
      variables: UpdateAccountMutationVariables;
      response: UpdateAccountMutation;
    }
  | {
      name: 'updateDocumentTemplateMutation';
      variables: UpdateDocumentTemplateMutationVariables;
      response: UpdateDocumentTemplateMutation;
    }
  | {
      name: 'updatePromptMutation';
      variables: UpdatePromptMutationVariables;
      response: UpdatePromptMutation;
    }
  | {
      name: 'updateServerRuntimeConfigsMutation';
      variables: UpdateServerRuntimeConfigsMutationVariables;
      response: UpdateServerRuntimeConfigsMutation;
    }
  | {
      name: 'updateSubscriptionMutation';
      variables: UpdateSubscriptionMutationVariables;
      response: UpdateSubscriptionMutation;
    }
  | {
      name: 'updateUserProfileMutation';
      variables: UpdateUserProfileMutationVariables;
      response: UpdateUserProfileMutation;
    }
  | {
      name: 'uploadAvatarMutation';
      variables: UploadAvatarMutationVariables;
      response: UploadAvatarMutation;
    }
  | {
      name: 'verifyEmailMutation';
      variables: VerifyEmailMutationVariables;
      response: VerifyEmailMutation;
    }
  | {
      name: 'setEnableAiMutation';
      variables: SetEnableAiMutationVariables;
      response: SetEnableAiMutation;
    }
  | {
      name: 'setEnableUrlPreviewMutation';
      variables: SetEnableUrlPreviewMutationVariables;
      response: SetEnableUrlPreviewMutation;
    }
  | {
      name: 'setWorkspaceExperimentalFeatureMutation';
      variables: SetWorkspaceExperimentalFeatureMutationVariables;
      response: SetWorkspaceExperimentalFeatureMutation;
    }
  | {
      name: 'addWorkspaceFeatureMutation';
      variables: AddWorkspaceFeatureMutationVariables;
      response: AddWorkspaceFeatureMutation;
    }
  | {
      name: 'removeWorkspaceFeatureMutation';
      variables: RemoveWorkspaceFeatureMutationVariables;
      response: RemoveWorkspaceFeatureMutation;
    }
  | {
      name: 'inviteByEmailMutation';
      variables: InviteByEmailMutationVariables;
      response: InviteByEmailMutation;
    }
  | {
      name: 'inviteByEmailsMutation';
      variables: InviteByEmailsMutationVariables;
      response: InviteByEmailsMutation;
    }
  | {
      name: 'acceptInviteByInviteIdMutation';
      variables: AcceptInviteByInviteIdMutationVariables;
      response: AcceptInviteByInviteIdMutation;
    }
  | {
      name: 'inviteBatchMutation';
      variables: InviteBatchMutationVariables;
      response: InviteBatchMutation;
    }
  | {
      name: 'createInviteLinkMutation';
      variables: CreateInviteLinkMutationVariables;
      response: CreateInviteLinkMutation;
    }
  | {
      name: 'revokeInviteLinkMutation';
      variables: RevokeInviteLinkMutationVariables;
      response: RevokeInviteLinkMutation;
    }
  | {
      name: 'approveWorkspaceTeamMemberMutation';
      variables: ApproveWorkspaceTeamMemberMutationVariables;
      response: ApproveWorkspaceTeamMemberMutation;
    }
  | {
      name: 'grantWorkspaceTeamMemberMutation';
      variables: GrantWorkspaceTeamMemberMutationVariables;
      response: GrantWorkspaceTeamMemberMutation;
    };
